export enum CtxCities {
  Abbott = 'abbott',
  Abernathy = 'abernathy',
  Abilene = 'abilene',
  Abram = 'abram',
  Ackerly = 'ackerly',
  Adamsville = 'adamsville',
  Addison = 'addison',
  Adkins = 'adkins',
  Adrian = 'adrian',
  AguaDulce = 'aguaDulce',
  Aguilares = 'aguilares',
  AirportHeights = 'airportHeights',
  AirportRoadAddition = 'airportRoadAddition',
  AlamoHeights = 'alamoHeights',
  Alba = 'alba',
  Albany = 'albany',
  Aldine = 'aldine',
  Aledo = 'aledo',
  Alfred = 'alfred',
  Alice = 'alice',
  AliceAcres = 'aliceAcres',
  Allen = 'allen',
  Alleyton = 'alleyton',
  Alma = 'alma',
  Alpine = 'alpine',
  Alto = 'alto',
  AltoBonitoHeights = 'altoBonitoHeights',
  Alton = 'alton',
  Alvarado = 'alvarado',
  Alvin = 'alvin',
  Alvord = 'alvord',
  AmadaAcres = 'amadaAcres',
  Amargosa = 'amargosa',
  Amaya = 'amaya',
  Ames = 'ames',
  Amherst = 'amherst',
  Amistad = 'amistad',
  Anacua = 'anacua',
  Anahuac = 'anahuac',
  Anderson = 'anderson',
  Andice = 'andice',
  Andrews = 'andrews',
  Angleton = 'angleton',
  Angus = 'angus',
  Anna = 'anna',
  Annetta = 'annetta',
  AnnettaNorth = 'annettaNorth',
  AnnettaSouth = 'annettaSouth',
  Annona = 'annona',
  Anson = 'anson',
  Anthony = 'anthony',
  Anton = 'anton',
  Appleby = 'appleby',
  Aquilla = 'aquilla',
  AransasPass = 'aransasPass',
  ArcherCity = 'archerCity',
  Arcola = 'arcola',
  Argyle = 'argyle',
  Arlington = 'arlington',
  Arp = 'arp',
  ArroyoColoradoeStates = 'arroyoColoradoeStates',
  ArroyoGardens = 'arroyoGardens',
  Asherton = 'asherton',
  Aspermont = 'aspermont',
  Atascocita = 'atascocita',
  Atascosa = 'atascosa',
  Athens = 'athens',
  Atlanta = 'atlanta',
  Aubrey = 'aubrey',
  Aurora = 'aurora',
  Austin = 'austin',
  Austwell = 'austwell',
  Avery = 'avery',
  Avinger = 'avinger',
  Axtell = 'axtell',
  Azle = 'azle',
  Bacliff = 'bacliff',
  Bailey = 'bailey',
  BaileysPrairie = 'baileysPrairie',
  Baird = 'baird',
  BalchSprings = 'balchSprings',
  BalconesHeights = 'balconesHeights',
  Ballinger = 'ballinger',
  Balmorhea = 'balmorhea',
  Bandera = 'bandera',
  Bangs = 'bangs',
  Banquete = 'banquete',
  Barclay = 'barclay',
  Bardwell = 'bardwell',
  Barrera = 'barrera',
  Barrett = 'barrett',
  Barry = 'barry',
  Barstow = 'barstow',
  Bartlett = 'bartlett',
  BartonCreek = 'bartonCreek',
  Bartonville = 'bartonville',
  Bastrop = 'bastrop',
  Batesville = 'batesville',
  BayCity = 'bayCity',
  BayouVista = 'bayouVista',
  Bayside = 'bayside',
  Baytown = 'baytown',
  Bayview = 'bayview',
  BeachCity = 'beachCity',
  BearCreek = 'bearCreek',
  Beasley = 'beasley',
  Beaumont = 'beaumont',
  Bebe = 'bebe',
  Beckville = 'beckville',
  Bedford = 'bedford',
  Bedias = 'bedias',
  BeeCave = 'beeCave',
  Beeville = 'beeville',
  Bellaire = 'bellaire',
  Bellevue = 'bellevue',
  Bellfalls = 'bellfalls',
  Bellmead = 'bellmead',
  Bells = 'bells',
  Bellville = 'bellville',
  Belmont = 'belmont',
  Belton = 'belton',
  Benavides = 'benavides',
  Benbrook = 'benbrook',
  Bend = 'bend',
  Benjamin = 'benjamin',
  BenjaminPerez = 'benjaminPerez',
  Berclair = 'berclair',
  Bergheim = 'bergheim',
  Berryville = 'berryville',
  Bertram = 'bertram',
  BeverlyHills = 'beverlyHills',
  BevilOaks = 'bevilOaks',
  BigLake = 'bigLake',
  BigSandy = 'bigSandy',
  BigSpring = 'bigSpring',
  BigThicketLakeeStates = 'bigThicketLakeeStates',
  BigWells = 'bigWells',
  Bigfoot = 'bigfoot',
  BishopHills = 'bishopHills',
  Bixby = 'bixby',
  Blackwell = 'blackwell',
  Blanco = 'blanco',
  Blanket = 'blanket',
  Blessing = 'blessing',
  Bloomburg = 'bloomburg',
  BloomingGrove = 'bloomingGrove',
  Bloomington = 'bloomington',
  Blossom = 'blossom',
  BlueBerryHill = 'blueBerryHill',
  BlueMound = 'blueMound',
  BlueRidge = 'blueRidge',
  Bluetown = 'bluetown',
  Blum = 'blum',
  Boerne = 'boerne',
  Bogata = 'bogata',
  Boling = 'boling',
  BolivarPeninsula = 'bolivarPeninsula',
  BonanzaHills = 'bonanzaHills',
  Bonham = 'bonham',
  Bonney = 'bonney',
  Booker = 'booker',
  Borger = 'borger',
  Botines = 'botines',
  Bovina = 'bovina',
  Bowie = 'bowie',
  BoxCanyon = 'boxCanyon',
  Boyd = 'boyd',
  BoysRanch = 'boysRanch',
  Bracken = 'bracken',
  Brackettville = 'brackettville',
  Brady = 'brady',
  Brandon = 'brandon',
  Brazoria = 'brazoria',
  BrazosBend = 'brazosBend',
  BrazosCountry = 'brazosCountry',
  Breckenridge = 'breckenridge',
  Bremond = 'bremond',
  Brenham = 'brenham',
  Briar = 'briar',
  Briarcliff = 'briarcliff',
  Briaroaks = 'briaroaks',
  BridgeCity = 'bridgeCity',
  Bridgeport = 'bridgeport',
  Briggs = 'briggs',
  Bristol = 'bristol',
  Broaddus = 'broaddus',
  Bronte = 'bronte',
  Brookshire = 'brookshire',
  BrooksideVillage = 'brooksideVillage',
  Browndell = 'browndell',
  Brownfield = 'brownfield',
  Brownsboro = 'brownsboro',
  Brownsville = 'brownsville',
  Brownwood = 'brownwood',
  BrucevilleEddy = 'brucevilleEddy',
  Brundage = 'brundage',
  Bruni = 'bruni',
  BrushyCreek = 'brushyCreek',
  Bryan = 'bryan',
  Bryson = 'bryson',
  BuchananDam = 'buchananDam',
  BuchananLakeVillage = 'buchananLakeVillage',
  Buckholts = 'buckholts',
  Buda = 'buda',
  BuenaVista = 'buenaVista',
  Buffalo = 'buffalo',
  BuffaloGap = 'buffaloGap',
  BuffaloSprings = 'buffaloSprings',
  Bullard = 'bullard',
  Bulverde = 'bulverde',
  Buna = 'buna',
  BunkerHillVillage = 'bunkerHillVillage',
  Burkburnett = 'burkburnett',
  Burke = 'burke',
  Burleson = 'burleson',
  Burlington = 'burlington',
  Burnet = 'burnet',
  Burton = 'burton',
  Butterfield = 'butterfield',
  Byers = 'byers',
  Bynum = 'bynum',
  Cactus = 'cactus',
  CaddoMills = 'caddoMills',
  Caldwell = 'caldwell',
  CallenderLake = 'callenderLake',
  Callisburg = 'callisburg',
  Calvert = 'calvert',
  Camargito = 'camargito',
  Cameron = 'cameron',
  CameronPark = 'cameronPark',
  CampSwift = 'campSwift',
  CampWood = 'campWood',
  Campbell = 'campbell',
  CampoVerde = 'campoVerde',
  Canadian = 'canadian',
  CaneyCity = 'caneyCity',
  Canton = 'canton',
  CantuAddition = 'cantuAddition',
  Canutillo = 'canutillo',
  Canyon = 'canyon',
  CanyonCreek = 'canyonCreek',
  CanyonLake = 'canyonLake',
  CapeRoyale = 'capeRoyale',
  Carbon = 'carbon',
  CarlsCorner = 'carlsCorner',
  Carlsbad = 'carlsbad',
  Carmine = 'carmine',
  CarrizoHill = 'carrizoHill',
  CarrizoSprings = 'carrizoSprings',
  Carrollton = 'carrollton',
  Carthage = 'carthage',
  CasaBlanca = 'casaBlanca',
  Casas = 'casas',
  CashionCommunity = 'cashionCommunity',
  CastleHills = 'castleHills',
  Castroville = 'castroville',
  Catarina = 'catarina',
  CedarCreek = 'cedarCreek',
  CedarHill = 'cedarHill',
  CedarPark = 'cedarPark',
  CedarPoint = 'cedarPoint',
  Celeste = 'celeste',
  Celina = 'celina',
  CensusPlaceName = 'censusPlaceName',
  Center = 'center',
  Centerville = 'centerville',
  CentralGardens = 'centralGardens',
  CesarChavez = 'cesarChavez',
  Chandler = 'chandler',
  Channelview = 'channelview',
  Channing = 'channing',
  Chaparrito = 'chaparrito',
  Chapeno = 'chapeno',
  Charlotte = 'charlotte',
  Chester = 'chester',
  Chico = 'chico',
  Childress = 'childress',
  Chillicothe = 'chillicothe',
  Chilton = 'chilton',
  China = 'china',
  ChinaGrove = 'chinaGrove',
  ChinaSpring = 'chinaSpring',
  Chireno = 'chireno',
  Christine = 'christine',
  Christoval = 'christoval',
  ChulaVista = 'chulaVista',
  Cibolo = 'cibolo',
  CienegasTerrace = 'cienegasTerrace',
  CincoRanch = 'cincoRanch',
  CircleDKceStates = 'circleDKceStates',
  Cisco = 'cisco',
  CitrusCity = 'citrusCity',
  Clarendon = 'clarendon',
  Clarksville = 'clarksville',
  ClarksvilleCity = 'clarksvilleCity',
  Claude = 'claude',
  ClearLakeShores = 'clearLakeShores',
  Cleburne = 'cleburne',
  Cleveland = 'cleveland',
  Clifton = 'clifton',
  Clint = 'clint',
  Cloverleaf = 'cloverleaf',
  Clute = 'clute',
  Clyde = 'clyde',
  Coahoma = 'coahoma',
  CockrellHill = 'cockrellHill',
  CoffeeCity = 'coffeeCity',
  Coldspring = 'coldspring',
  Coleman = 'coleman',
  CollegeStation = 'collegeStation',
  Colleyville = 'colleyville',
  Collinsville = 'collinsville',
  Colmesneil = 'colmesneil',
  ColoradoAcres = 'coloradoAcres',
  ColoradoCity = 'coloradoCity',
  Columbus = 'columbus',
  Comanche = 'comanche',
  Combes = 'combes',
  Combine = 'combine',
  Comfort = 'comfort',
  Commerce = 'commerce',
  Como = 'como',
  Concan = 'concan',
  Concepcion = 'concepcion',
  Conroe = 'conroe',
  Converse = 'converse',
  Cool = 'cool',
  Coolidge = 'coolidge',
  Cooper = 'cooper',
  Coppell = 'coppell',
  CopperCanyon = 'copperCanyon',
  CopperasCove = 'copperasCove',
  Corinth = 'corinth',
  CorpusChristi = 'corpusChristi',
  CorralCity = 'corralCity',
  Corrigan = 'corrigan',
  Corsicana = 'corsicana',
  Cost = 'cost',
  Cottonwood = 'cottonwood',
  CottonwoodShores = 'cottonwoodShores',
  Cotulla = 'cotulla',
  CountryAcres = 'countryAcres',
  Coupland = 'coupland',
  Cove = 'cove',
  Covington = 'covington',
  Coyanosa = 'coyanosa',
  CoyoteAcres = 'coyoteAcres',
  CoyoteFlats = 'coyoteFlats',
  Crandall = 'crandall',
  Crane = 'crane',
  CranfillsGap = 'cranfillsGap',
  Crawford = 'crawford',
  Creedmoor = 'creedmoor',
  Cresson = 'cresson',
  Crockett = 'crockett',
  Crosby = 'crosby',
  Crosbyton = 'crosbyton',
  CrossMountain = 'crossMountain',
  CrossPlains = 'crossPlains',
  CrossRoads = 'crossRoads',
  CrossTimber = 'crossTimber',
  Crowell = 'crowell',
  Crowley = 'crowley',
  CrystalCity = 'crystalCity',
  Cuero = 'cuero',
  Cuevitas = 'cuevitas',
  Cumby = 'cumby',
  Cumings = 'cumings',
  Cuney = 'cuney',
  Cushing = 'cushing',
  CutandShoot = 'cutandShoot',
  DHanis = 'dHanis',
  Daingerfield = 'daingerfield',
  Daisetta = 'daisetta',
  Dale = 'dale',
  Dalhart = 'dalhart',
  Dallas = 'dallas',
  DalworthingtonGardens = 'dalworthingtonGardens',
  Damon = 'damon',
  Danbury = 'danbury',
  Darrouzett = 'darrouzett',
  Dawson = 'dawson',
  Dayton = 'dayton',
  DaytonLakes = 'daytonLakes',
  DeKalb = 'deKalb',
  DeLeon = 'deLeon',
  Dean = 'dean',
  Decatur = 'decatur',
  DeCordova = 'deCordova',
  DeerPark = 'deerPark',
  DelMarHeights = 'delMarHeights',
  DelRio = 'delRio',
  DelSol = 'delSol',
  DelValle = 'delValle',
  DellCity = 'dellCity',
  Delmita = 'delmita',
  Denison = 'denison',
  Denton = 'denton',
  DenverCity = 'denverCity',
  Deport = 'deport',
  Desdemona = 'desdemona',
  DeSoto = 'deSoto',
  Detroit = 'detroit',
  Devers = 'devers',
  Devine = 'devine',
  Deweyville = 'deweyville',
  Diboll = 'diboll',
  Dickens = 'dickens',
  Dickinson = 'dickinson',
  Dilley = 'dilley',
  Dimmitt = 'dimmitt',
  DISH = 'dISH',
  DoddCity = 'doddCity',
  Dodson = 'dodson',
  Doffing = 'doffing',
  Domino = 'domino',
  Donie = 'donie',
  Donna = 'donna',
  Doolittle = 'doolittle',
  Dorchester = 'dorchester',
  DoubleOak = 'doubleOak',
  Douglassville = 'douglassville',
  Doyle = 'doyle',
  Driftwood = 'driftwood',
  DrippingSprings = 'drippingSprings',
  DrippingSpringsRanchRd = 'drippingSpringsRanchRd',
  Driscoll = 'driscoll',
  Dublin = 'dublin',
  Dumas = 'dumas',
  Duncanville = 'duncanville',
  EagleLake = 'eagleLake',
  EaglePass = 'eaglePass',
  Early = 'early',
  Earth = 'earth',
  EastAltoBonito = 'eastAltoBonito',
  EastBernard = 'eastBernard',
  EastLopez = 'eastLopez',
  EastMountain = 'eastMountain',
  EastTawakoni = 'eastTawakoni',
  Eastland = 'eastland',
  Easton = 'easton',
  Ector = 'ector',
  Edcouch = 'edcouch',
  Eddy = 'eddy',
  Eden = 'eden',
  EdgecliffVillage = 'edgecliffVillage',
  EdgewatereStates = 'edgewatereStates',
  Edgewood = 'edgewood',
  Edinburg = 'edinburg',
  Edmonson = 'edmonson',
  Edna = 'edna',
  Edom = 'edom',
  Edroy = 'edroy',
  EidsonRoad = 'eidsonRoad',
  ElBrazil = 'elBrazil',
  ElCaminoAngosto = 'elCaminoAngosto',
  ElCampo = 'elCampo',
  ElCastillo = 'elCastillo',
  ElCenizo = 'elCenizo',
  ElChaparral = 'elChaparral',
  ElIndio = 'elIndio',
  ElLago = 'elLago',
  ElMesquite = 'elMesquite',
  ElPaso = 'elPaso',
  ElQuiote = 'elQuiote',
  ElRanchoVela = 'elRanchoVela',
  ElRefugio = 'elRefugio',
  ElSocio = 'elSocio',
  ElToro = 'elToro',
  Elbert = 'elbert',
  Eldorado = 'eldorado',
  Electra = 'electra',
  Elgin = 'elgin',
  EliasFelaSolis = 'eliasFelaSolis',
  Elkhart = 'elkhart',
  Ellinger = 'ellinger',
  ElmCreek = 'elmCreek',
  ElmMott = 'elmMott',
  Elmendorf = 'elmendorf',
  Elmo = 'elmo',
  Elsa = 'elsa',
  EmeraldBay = 'emeraldBay',
  Emhouse = 'emhouse',
  Emory = 'emory',
  EncantadaRanchitoElCalaboz = 'encantadaRanchitoElCalaboz',
  EnchantedOaks = 'enchantedOaks',
  Encinal = 'encinal',
  Encino = 'encino',
  Ennis = 'ennis',
  Escobares = 'escobares',
  Estelline = 'estelline',
  EugenioSaenz = 'eugenioSaenz',
  Euless = 'euless',
  Eureka = 'eureka',
  Eustace = 'eustace',
  Evadale = 'evadale',
  Evant = 'evant',
  Evergreen = 'evergreen',
  Everman = 'everman',
  Ezzell = 'ezzell',
  Fabens = 'fabens',
  Fabrica = 'fabrica',
  FairOaksRanch = 'fairOaksRanch',
  Fairchilds = 'fairchilds',
  Fairfield = 'fairfield',
  Fairview = 'fairview',
  FalconHeights = 'falconHeights',
  FalconLakeeStates = 'falconLakeeStates',
  FalconMesa = 'falconMesa',
  FalconVillage = 'falconVillage',
  Falconaire = 'falconaire',
  Falfurrias = 'falfurrias',
  FallsCity = 'fallsCity',
  Falman = 'falman',
  Fannett = 'fannett',
  Fannin = 'fannin',
  FarmersBranch = 'farmersBranch',
  Farmersville = 'farmersville',
  Farwell = 'farwell',
  Fate = 'fate',
  Fayetteville = 'fayetteville',
  Faysville = 'faysville',
  Fentress = 'fentress',
  FernandoSalinas = 'fernandoSalinas',
  Ferris = 'ferris',
  FifthStreet = 'fifthStreet',
  Fischer = 'fischer',
  Flat = 'flat',
  Flatonia = 'flatonia',
  FlordelRio = 'flordelRio',
  Florence = 'florence',
  Floresville = 'floresville',
  Flowella = 'flowella',
  FlowerMound = 'flowerMound',
  Floydada = 'floydada',
  Follett = 'follett',
  ForestHill = 'forestHill',
  Forney = 'forney',
  Forsan = 'forsan',
  FortBliss = 'fortBliss',
  FortClarkSprings = 'fortClarkSprings',
  FortDavis = 'fortDavis',
  FortHancock = 'fortHancock',
  FortHood = 'fortHood',
  FortStockton = 'fortStockton',
  FortWorth = 'fortWorth',
  FourCorners = 'fourCorners',
  FourPoints = 'fourPoints',
  Fowlerton = 'fowlerton',
  Francitas = 'francitas',
  Franklin = 'franklin',
  Frankston = 'frankston',
  Fredericksburg = 'fredericksburg',
  Freeport = 'freeport',
  Freer = 'freer',
  Fresno = 'fresno',
  Friendswood = 'friendswood',
  Friona = 'friona',
  Frisco = 'frisco',
  Fritch = 'fritch',
  Fronton = 'fronton',
  FrontonRanchettes = 'frontonRanchettes',
  Frost = 'frost',
  Fruitvale = 'fruitvale',
  Fulshear = 'fulshear',
  Fulton = 'fulton',
  Gail = 'gail',
  Gainesville = 'gainesville',
  GalenaPark = 'galenaPark',
  Gallatin = 'gallatin',
  Galveston = 'galveston',
  Ganado = 'ganado',
  Garceno = 'garceno',
  Garciasville = 'garciasville',
  GardenCity = 'gardenCity',
  GardenRidge = 'gardenRidge',
  Gardendale = 'gardendale',
  Garfield = 'garfield',
  Garland = 'garland',
  Garrett = 'garrett',
  Garrison = 'garrison',
  Garwood = 'garwood',
  GaryCity = 'garyCity',
  GarzaSalinasII = 'garzaSalinasII',
  Gatesville = 'gatesville',
  Gause = 'gause',
  GeorgeWest = 'georgeWest',
  Georgetown = 'georgetown',
  Geronimo = 'geronimo',
  Gholson = 'gholson',
  Giddings = 'giddings',
  Gilchrist = 'gilchrist',
  Gillett = 'gillett',
  Gilmer = 'gilmer',
  Girard = 'girard',
  Gladewater = 'gladewater',
  GlenRose = 'glenRose',
  GlennHeights = 'glennHeights',
  Glidden = 'glidden',
  Godley = 'godley',
  Goldsmith = 'goldsmith',
  Goldthwaite = 'goldthwaite',
  Goliad = 'goliad',
  Golinda = 'golinda',
  Gonzales = 'gonzales',
  Goodlow = 'goodlow',
  Goodrich = 'goodrich',
  Gordon = 'gordon',
  Goree = 'goree',
  Gorman = 'gorman',
  Graford = 'graford',
  Graham = 'graham',
  Granbury = 'granbury',
  GrandAcres = 'grandAcres',
  GrandPrairie = 'grandPrairie',
  GrandSaline = 'grandSaline',
  Grandfalls = 'grandfalls',
  Grandview = 'grandview',
  Granger = 'granger',
  GraniteShoals = 'graniteShoals',
  Granjeno = 'granjeno',
  GrapeCreek = 'grapeCreek',
  Grapeland = 'grapeland',
  Grapevine = 'grapevine',
  GraysPrairie = 'graysPrairie',
  Greatwood = 'greatwood',
  GreenValleyFarms = 'greenValleyFarms',
  Greenville = 'greenville',
  Gregory = 'gregory',
  GreyForest = 'greyForest',
  Groesbeck = 'groesbeck',
  Groom = 'groom',
  Groves = 'groves',
  Groveton = 'groveton',
  Gruver = 'gruver',
  GuadalupeGuerra = 'guadalupeGuerra',
  Guerra = 'guerra',
  GunBarrelCity = 'gunBarrelCity',
  Gunter = 'gunter',
  Gustine = 'gustine',
  Guthrie = 'guthrie',
  Gutierrez = 'gutierrez',
  HCuellareStates = 'hCuellareStates',
  Hackberry = 'hackberry',
  HaleCenter = 'haleCenter',
  Hallettsville = 'hallettsville',
  Hallsburg = 'hallsburg',
  Hallsville = 'hallsville',
  HaltomCity = 'haltomCity',
  Hamilton = 'hamilton',
  Hamlin = 'hamlin',
  Happy = 'happy',
  Hardin = 'hardin',
  Hargill = 'hargill',
  HarkerHeights = 'harkerHeights',
  Harlingen = 'harlingen',
  Harper = 'harper',
  Hart = 'hart',
  Hartley = 'hartley',
  Harwood = 'harwood',
  Haskell = 'haskell',
  Haslet = 'haslet',
  Havana = 'havana',
  HawkCove = 'hawkCove',
  Hawkins = 'hawkins',
  Hawley = 'hawley',
  Hays = 'hays',
  Hearne = 'hearne',
  Heath = 'heath',
  Hebbronville = 'hebbronville',
  Hebron = 'hebron',
  Hedley = 'hedley',
  HedwigVillage = 'hedwigVillage',
  Heidelberg = 'heidelberg',
  Heidenheimer = 'heidenheimer',
  Helotes = 'helotes',
  Hemphill = 'hemphill',
  Hempstead = 'hempstead',
  Henderson = 'henderson',
  Henly = 'henly',
  Henrietta = 'henrietta',
  Hereford = 'hereford',
  Hermleigh = 'hermleigh',
  Hewitt = 'hewitt',
  HickoryCreek = 'hickoryCreek',
  Hico = 'hico',
  Hidalgo = 'hidalgo',
  Hideaway = 'hideaway',
  Higgins = 'higgins',
  HighlandHaven = 'highlandHaven',
  HighlandPark = 'highlandPark',
  HighlandVillage = 'highlandVillage',
  Highlands = 'highlands',
  HillCountryVillage = 'hillCountryVillage',
  Hillcrest = 'hillcrest',
  Hillsboro = 'hillsboro',
  HillsideAcres = 'hillsideAcres',
  Hilltop = 'hilltop',
  HilltopLakes = 'hilltopLakes',
  HilshireVillage = 'hilshireVillage',
  Hitchcock = 'hitchcock',
  Hobson = 'hobson',
  HolidayBeach = 'holidayBeach',
  HolidayLakes = 'holidayLakes',
  Holland = 'holland',
  Holliday = 'holliday',
  HollyLakeRanch = 'hollyLakeRanch',
  HollywoodPark = 'hollywoodPark',
  HomesteadMeadowsNorth = 'homesteadMeadowsNorth',
  HomesteadMeadowsSouth = 'homesteadMeadowsSouth',
  Hondo = 'hondo',
  HoneyGrove = 'honeyGrove',
  Hooks = 'hooks',
  HorizonCity = 'horizonCity',
  HornsbyBend = 'hornsbyBend',
  HorseshoeBay = 'horseshoeBay',
  HorseshoeBend = 'horseshoeBend',
  Houston = 'houston',
  Howardwick = 'howardwick',
  Howe = 'howe',
  Hubbard = 'hubbard',
  Hudson = 'hudson',
  HudsonBend = 'hudsonBend',
  HudsonOaks = 'hudsonOaks',
  HughesSprings = 'hughesSprings',
  Hull = 'hull',
  Humble = 'humble',
  Hungerford = 'hungerford',
  Hunt = 'hunt',
  HuntersCreekVillage = 'huntersCreekVillage',
  Huntington = 'huntington',
  Huntsville = 'huntsville',
  Hurst = 'hurst',
  Hutchins = 'hutchins',
  Hutto = 'hutto',
  Huxley = 'huxley',
  Hye = 'hye',
  Iago = 'iago',
  Idalou = 'idalou',
  IglesiaAntigua = 'iglesiaAntigua',
  Impact = 'impact',
  Imperial = 'imperial',
  IndianGap = 'indianGap',
  IndianHills = 'indianHills',
  IndianLake = 'indianLake',
  IndianSprings = 'indianSprings',
  Indio = 'indio',
  Industry = 'industry',
  Inez = 'inez',
  Ingleside = 'ingleside',
  InglesideontheBay = 'inglesideontheBay',
  Ingram = 'ingram',
  Iola = 'iola',
  IowaColony = 'iowaColony',
  IowaPark = 'iowaPark',
  Iraan = 'iraan',
  Iredell = 'iredell',
  Irving = 'irving',
  Italy = 'italy',
  Itasca = 'itasca',
  Ivanhoe = 'ivanhoe',
  JacintoCity = 'jacintoCity',
  Jacksboro = 'jacksboro',
  Jacksonville = 'jacksonville',
  JamaicaBeach = 'jamaicaBeach',
  JardindeSanJulian = 'jardindeSanJulian',
  Jarrell = 'jarrell',
  Jasper = 'jasper',
  Jayton = 'jayton',
  Jefferson = 'jefferson',
  JerseyVillage = 'jerseyVillage',
  Jewett = 'jewett',
  JFVillarreal = 'jFVillarreal',
  Joaquin = 'joaquin',
  JohnsonCity = 'johnsonCity',
  Jolly = 'jolly',
  JonesCreek = 'jonesCreek',
  Jonesboro = 'jonesboro',
  Jonestown = 'jonestown',
  Josephine = 'josephine',
  Joshua = 'joshua',
  Jourdanton = 'jourdanton',
  Juarez = 'juarez',
  Junction = 'junction',
  Justin = 'justin',
  KBarRanch = 'kBarRanch',
  KarnesCity = 'karnesCity',
  Katy = 'katy',
  Kaufman = 'kaufman',
  Keene = 'keene',
  Keller = 'keller',
  Kemah = 'kemah',
  Kemp = 'kemp',
  Kempner = 'kempner',
  Kendalia = 'kendalia',
  Kendleton = 'kendleton',
  Kenedy = 'kenedy',
  Kenefick = 'kenefick',
  Kennard = 'kennard',
  Kennedale = 'kennedale',
  Kerens = 'kerens',
  Kermit = 'kermit',
  Kerrville = 'kerrville',
  Kilgore = 'kilgore',
  Killeen = 'killeen',
  Kingsbury = 'kingsbury',
  Kingsland = 'kingsland',
  Kingsville = 'kingsville',
  Kirby = 'kirby',
  Kirbyville = 'kirbyville',
  Kirvin = 'kirvin',
  Knippa = 'knippa',
  Knollwood = 'knollwood',
  KnoxCity = 'knoxCity',
  Kopperl = 'kopperl',
  Kosse = 'kosse',
  Kountze = 'kountze',
  Kress = 'kress',
  Krugerville = 'krugerville',
  Krum = 'krum',
  Kurten = 'kurten',
  Kyle = 'kyle',
  LaBlanca = 'laBlanca',
  LaCarla = 'laCarla',
  LaCasita = 'laCasita',
  LaChuparosa = 'laChuparosa',
  LaComa = 'laComa',
  LaEscondida = 'laEscondida',
  LaEsperanza = 'laEsperanza',
  LaFeria = 'laFeria',
  LaFeriaNorth = 'laFeriaNorth',
  LaGrange = 'laGrange',
  LaGrulla = 'laGrulla',
  LaHoma = 'laHoma',
  LaJoya = 'laJoya',
  LaLomadeFalcon = 'laLomadeFalcon',
  LaMarque = 'laMarque',
  LaMinita = 'laMinita',
  LaPaloma = 'laPaloma',
  LaPalomaAddition = 'laPalomaAddition',
  LaPalomaRanchettes = 'laPalomaRanchettes',
  LaPalomaLostCreek = 'laPalomaLostCreek',
  LaPorte = 'laPorte',
  LaPresa = 'laPresa',
  LaPryor = 'laPryor',
  LaPuerta = 'laPuerta',
  LaRosita = 'laRosita',
  LaTinaRanch = 'laTinaRanch',
  LaVernia = 'laVernia',
  LaVictoria = 'laVictoria',
  LaVilla = 'laVilla',
  LaWard = 'laWard',
  LacklandAFB = 'lacklandAFB',
  LaCoste = 'laCoste',
  LacyLakeview = 'lacyLakeview',
  Ladonia = 'ladonia',
  Lago = 'lago',
  LagoVista = 'lagoVista',
  LagunaHeights = 'lagunaHeights',
  LagunaPark = 'lagunaPark',
  LagunaSeca = 'lagunaSeca',
  LagunaVista = 'lagunaVista',
  LakeBridgeport = 'lakeBridgeport',
  LakeBrownwood = 'lakeBrownwood',
  LakeBryan = 'lakeBryan',
  LakeCherokee = 'lakeCherokee',
  LakeCity = 'lakeCity',
  LakeColoradoCity = 'lakeColoradoCity',
  LakeDallas = 'lakeDallas',
  LakeDunlap = 'lakeDunlap',
  LakeJackson = 'lakeJackson',
  LakeKiowa = 'lakeKiowa',
  LakeMedinaShores = 'lakeMedinaShores',
  LakeMereditheStates = 'lakeMereditheStates',
  LakeTanglewood = 'lakeTanglewood',
  LakeView = 'lakeView',
  LakeWorth = 'lakeWorth',
  Lakehills = 'lakehills',
  Lakeport = 'lakeport',
  LakeshoreGardensHiddenAcres = 'lakeshoreGardensHiddenAcres',
  Lakeside = 'lakeside',
  LakesideCity = 'lakesideCity',
  Lakeway = 'lakeway',
  LakewoodVillage = 'lakewoodVillage',
  Lamar = 'lamar',
  Lamesa = 'lamesa',
  Lampasas = 'lampasas',
  Lancaster = 'lancaster',
  Lanham = 'lanham',
  Lantana = 'lantana',
  Laredo = 'laredo',
  LaredoRanchettes = 'laredoRanchettes',
  LaredoRanchettesWest = 'laredoRanchettesWest',
  LasHaciendas = 'lasHaciendas',
  LasLomas = 'lasLomas',
  LasLomitas = 'lasLomitas',
  LasPalmas = 'lasPalmas',
  LasPalmasII = 'lasPalmasII',
  LasPilas = 'lasPilas',
  LasQuintasFronterizas = 'lasQuintasFronterizas',
  LaSalle = 'laSalle',
  Lasana = 'lasana',
  Lasara = 'lasara',
  Latexo = 'latexo',
  LaughlinAFB = 'laughlinAFB',
  Laureles = 'laureles',
  Lavon = 'lavon',
  Lawn = 'lawn',
  LeagueCity = 'leagueCity',
  Leakey = 'leakey',
  Leander = 'leander',
  Leary = 'leary',
  Ledbetter = 'ledbetter',
  Leesville = 'leesville',
  Lefors = 'lefors',
  Leming = 'leming',
  LeonValley = 'leonValley',
  Leona = 'leona',
  Leonard = 'leonard',
  Leroy = 'leroy',
  Levelland = 'levelland',
  Lewisville = 'lewisville',
  Lexington = 'lexington',
  Liberty = 'liberty',
  LibertyCity = 'libertyCity',
  LibertyHill = 'libertyHill',
  LincolnPark = 'lincolnPark',
  Lindale = 'lindale',
  Linden = 'linden',
  Lindsay = 'lindsay',
  Linn = 'linn',
  Lipan = 'lipan',
  Lipscomb = 'lipscomb',
  LittleElm = 'littleElm',
  LittleRiverAcademy = 'littleRiverAcademy',
  Littlefield = 'littlefield',
  LiveOak = 'liveOak',
  Liverpool = 'liverpool',
  Livingston = 'livingston',
  Llano = 'llano',
  LlanoGrande = 'llanoGrande',
  Lockhart = 'lockhart',
  Lockney = 'lockney',
  LogCabin = 'logCabin',
  Lolita = 'lolita',
  LomaGrande = 'lomaGrande',
  LomaLinda = 'lomaLinda',
  LomaLindaEast = 'lomaLindaEast',
  LomaLindaWest = 'lomaLindaWest',
  LomaVista = 'lomaVista',
  Lometa = 'lometa',
  LoneOak = 'loneOak',
  LoneStar = 'loneStar',
  Longoria = 'longoria',
  Longview = 'longview',
  Loop = 'loop',
  Lopeño = 'lopeño',
  Lopezville = 'lopezville',
  Loraine = 'loraine',
  Lorena = 'lorena',
  Lorenzo = 'lorenzo',
  LosAltos = 'losAltos',
  LosAlvarez = 'losAlvarez',
  LosAngeles = 'losAngeles',
  LosArcos = 'losArcos',
  LosArrieros = 'losArrieros',
  LosBarreras = 'losBarreras',
  LosCentenarios = 'losCentenarios',
  LosCorralitos = 'losCorralitos',
  LosEbanos = 'losEbanos',
  LosFresnos = 'losFresnos',
  LosHuisaches = 'losHuisaches',
  LosIndios = 'losIndios',
  LosMinerales = 'losMinerales',
  LosNopalitos = 'losNopalitos',
  LosVeteranosI = 'losVeteranosI',
  LosVeteranosII = 'losVeteranosII',
  LosYbanez = 'losYbanez',
  LostCreek = 'lostCreek',
  Lott = 'lott',
  Louise = 'louise',
  Lovelady = 'lovelady',
  LowryCrossing = 'lowryCrossing',
  Lozano = 'lozano',
  Lubbock = 'lubbock',
  Lucas = 'lucas',
  Lueders = 'lueders',
  Lufkin = 'lufkin',
  Luling = 'luling',
  Lumberton = 'lumberton',
  Lyford = 'lyford',
  Lytle = 'lytle',
  LyttonSprings = 'lyttonSprings',
  Mabank = 'mabank',
  Macdona = 'macdona',
  Madisonville = 'madisonville',
  Magnolia = 'magnolia',
  Malakoff = 'malakoff',
  Malone = 'malone',
  Manchaca = 'manchaca',
  Manor = 'manor',
  Mansfield = 'mansfield',
  ManuelGarcia = 'manuelGarcia',
  ManuelGarciaII = 'manuelGarciaII',
  Manvel = 'manvel',
  Marathon = 'marathon',
  MarbleFalls = 'marbleFalls',
  Marfa = 'marfa',
  Marietta = 'marietta',
  Marion = 'marion',
  Markham = 'markham',
  Marlin = 'marlin',
  Marquez = 'marquez',
  Marshall = 'marshall',
  Mart = 'mart',
  Martindale = 'martindale',
  Martinez = 'martinez',
  Mason = 'mason',
  Matador = 'matador',
  Matagorda = 'matagorda',
  Mathis = 'mathis',
  Maud = 'maud',
  Mauriceville = 'mauriceville',
  Maxwell = 'maxwell',
  Maypearl = 'maypearl',
  Maysfield = 'maysfield',
  McAllen = 'mcAllen',
  McCamey = 'mcCamey',
  McDade = 'mcDade',
  McGregor = 'mcGregor',
  McKinney = 'mcKinney',
  McKinneyAcres = 'mcKinneyAcres',
  McLean = 'mcLean',
  McLendonChisholm = 'mcLendonChisholm',
  McMahan = 'mcMahan',
  McNeil = 'mcNeil',
  McQueeney = 'mcQueeney',
  Meadow = 'meadow',
  Meadowlakes = 'meadowlakes',
  MeadowsPlace = 'meadowsPlace',
  Medina = 'medina',
  Megargel = 'megargel',
  Melissa = 'melissa',
  Melvin = 'melvin',
  Memphis = 'memphis',
  Menard = 'menard',
  Mentone = 'mentone',
  Mercedes = 'mercedes',
  Meridian = 'meridian',
  Merkel = 'merkel',
  Mertens = 'mertens',
  Mertzon = 'mertzon',
  Mesquite = 'mesquite',
  Mexia = 'mexia',
  Meyersville = 'meyersville',
  MiRanchitoEstate = 'miRanchitoEstate',
  Miami = 'miami',
  Mico = 'mico',
  Midfield = 'midfield',
  Midland = 'midland',
  Midlothian = 'midlothian',
  Midway = 'midway',
  MidwayNorth = 'midwayNorth',
  MidwaySouth = 'midwaySouth',
  MiguelBarrera = 'miguelBarrera',
  Mikes = 'mikes',
  MilaDoce = 'milaDoce',
  Milam = 'milam',
  Milano = 'milano',
  Mildred = 'mildred',
  Miles = 'miles',
  Milford = 'milford',
  MillersCove = 'millersCove',
  Millican = 'millican',
  Millsap = 'millsap',
  Mineola = 'mineola',
  MineralWells = 'mineralWells',
  Mingus = 'mingus',
  MirandoCity = 'mirandoCity',
  Mission = 'mission',
  MissionBend = 'missionBend',
  MissouriCity = 'missouriCity',
  Mobeetie = 'mobeetie',
  MobileCity = 'mobileCity',
  Moffat = 'moffat',
  Monahans = 'monahans',
  MontBelvieu = 'montBelvieu',
  Montague = 'montague',
  Montalba = 'montalba',
  MonteAlto = 'monteAlto',
  Montgomery = 'montgomery',
  Moody = 'moody',
  Moore = 'moore',
  MooreStation = 'mooreStation',
  Moraida = 'moraida',
  MoralesSanchez = 'moralesSanchez',
  Moran = 'moran',
  Morgan = 'morgan',
  MorganFarm = 'morganFarm',
  MorgansPoint = 'morgansPoint',
  MorgansPointResort = 'morgansPointResort',
  MorningGlory = 'morningGlory',
  Morse = 'morse',
  Morton = 'morton',
  Moulton = 'moulton',
  Mound = 'mound',
  MountCalm = 'mountCalm',
  MountEnterprise = 'mountEnterprise',
  MountPleasant = 'mountPleasant',
  MountVernon = 'mountVernon',
  MountainCity = 'mountainCity',
  MountainHome = 'mountainHome',
  Muenster = 'muenster',
  Muleshoe = 'muleshoe',
  Mullin = 'mullin',
  Munday = 'munday',
  Muniz = 'muniz',
  Murchison = 'murchison',
  Murillo = 'murillo',
  Murphy = 'murphy',
  Mustang = 'mustang',
  MustangRidge = 'mustangRidge',
  MyrtleSprings = 'myrtleSprings',
  Nacogdoches = 'nacogdoches',
  Nada = 'nada',
  Naples = 'naples',
  NarcisoPena = 'narcisoPena',
  Naruna = 'naruna',
  Nash = 'nash',
  NassauBay = 'nassauBay',
  Natalia = 'natalia',
  Navarro = 'navarro',
  Navasota = 'navasota',
  Nazareth = 'nazareth',
  Nederland = 'nederland',
  Needville = 'needville',
  Nesbitt = 'nesbitt',
  Netos = 'netos',
  Nevada = 'nevada',
  NewBerlin = 'newBerlin',
  NewBoston = 'newBoston',
  NewBraunfels = 'newBraunfels',
  NewChapelHill = 'newChapelHill',
  NewDeal = 'newDeal',
  NewFairview = 'newFairview',
  NewFalcon = 'newFalcon',
  NewHome = 'newHome',
  NewHope = 'newHope',
  NewLondon = 'newLondon',
  NewSummerfield = 'newSummerfield',
  NewTerritory = 'newTerritory',
  NewWaverly = 'newWaverly',
  Newark = 'newark',
  Newcastle = 'newcastle',
  Newton = 'newton',
  Neylandville = 'neylandville',
  Niederwald = 'niederwald',
  Nina = 'nina',
  Nixon = 'nixon',
  Nocona = 'nocona',
  NoconaHills = 'noconaHills',
  Nolanville = 'nolanville',
  Nome = 'nome',
  Noonday = 'noonday',
  Nordheim = 'nordheim',
  Normangee = 'normangee',
  Normanna = 'normanna',
  NorthAlamo = 'northAlamo',
  NorthCleveland = 'northCleveland',
  NorthEscobares = 'northEscobares',
  NorthPearsall = 'northPearsall',
  NorthRichlandHills = 'northRichlandHills',
  NorthSanPedro = 'northSanPedro',
  Northlake = 'northlake',
  Northridge = 'northridge',
  Novice = 'novice',
  Nursery = 'nursery',
  OBrien = 'oBrien',
  ODonnell = 'oDonnell',
  OakGrove = 'oakGrove',
  OakIsland = 'oakIsland',
  OakLeaf = 'oakLeaf',
  OakPoint = 'oakPoint',
  OakRidge = 'oakRidge',
  OakRidgeNorth = 'oakRidgeNorth',
  OakTrailShores = 'oakTrailShores',
  OakValley = 'oakValley',
  Oakalla = 'oakalla',
  Oakhurst = 'oakhurst',
  Oakwood = 'oakwood',
  Odem = 'odem',
  Odessa = 'odessa',
  Oglesby = 'oglesby',
  Oilton = 'oilton',
  OldRiverWinfree = 'oldRiverWinfree',
  Olivarez = 'olivarez',
  OliviaLopezdeGutierrez = 'oliviaLopezdeGutierrez',
  Olmito = 'olmito',
  OlmitoandOlmito = 'olmitoandOlmito',
  OlmosPark = 'olmosPark',
  Olney = 'olney',
  Olton = 'olton',
  Omaha = 'omaha',
  Onalaska = 'onalaska',
  OpdykeWest = 'opdykeWest',
  Orange = 'orange',
  OrangeGrove = 'orangeGrove',
  Orason = 'orason',
  Orchard = 'orchard',
  OreCity = 'oreCity',
  Other = 'other',
  Ottine = 'ottine',
  Overton = 'overton',
  Ovilla = 'ovilla',
  OwlRanch = 'owlRanch',
  OysterCreek = 'oysterCreek',
  Ozona = 'ozona',
  PabloPena = 'pabloPena',
  Paducah = 'paducah',
  Paige = 'paige',
  PaintRock = 'paintRock',
  PaisanoPark = 'paisanoPark',
  Palacios = 'palacios',
  Palestine = 'palestine',
  Palisades = 'palisades',
  PalmValley = 'palmValley',
  Palmer = 'palmer',
  Palmhurst = 'palmhurst',
  Palmview = 'palmview',
  PalmviewSouth = 'palmviewSouth',
  PaloBlanco = 'paloBlanco',
  PaloPinto = 'paloPinto',
  PalomaCreek = 'palomaCreek',
  PalomaCreekSouth = 'palomaCreekSouth',
  Pampa = 'pampa',
  Pandora = 'pandora',
  Panhandle = 'panhandle',
  PanoramaVillage = 'panoramaVillage',
  Pantego = 'pantego',
  Paradise = 'paradise',
  Paris = 'paris',
  Parker = 'parker',
  Pasadena = 'pasadena',
  Pattison = 'pattison',
  PattonVillage = 'pattonVillage',
  Pawnee = 'pawnee',
  PayneSprings = 'payneSprings',
  Pearland = 'pearland',
  Pearsall = 'pearsall',
  PecanAcres = 'pecanAcres',
  PecanGap = 'pecanGap',
  PecanGrove = 'pecanGrove',
  PecanHill = 'pecanHill',
  PecanPlantation = 'pecanPlantation',
  Pecos = 'pecos',
  PelicanBay = 'pelicanBay',
  Pena = 'pena',
  Pendleton = 'pendleton',
  Penelope = 'penelope',
  Penitas = 'penitas',
  Perezville = 'perezville',
  Perrin = 'perrin',
  Perry = 'perry',
  Perryton = 'perryton',
  Petersburg = 'petersburg',
  Petrolia = 'petrolia',
  Petronila = 'petronila',
  Pettus = 'pettus',
  Pflugerville = 'pflugerville',
  Pharr = 'pharr',
  Pidcoke = 'pidcoke',
  PilotPoint = 'pilotPoint',
  PineForest = 'pineForest',
  PineHarbor = 'pineHarbor',
  PineIsland = 'pineIsland',
  Pinehurst = 'pinehurst',
  Pineland = 'pineland',
  PinewoodeStates = 'pinewoodeStates',
  PineyPointVillage = 'pineyPointVillage',
  PipeCreek = 'pipeCreek',
  Pittsburg = 'pittsburg',
  Placedo = 'placedo',
  Plains = 'plains',
  Plainview = 'plainview',
  Plano = 'plano',
  Pleak = 'pleak',
  PleasantHill = 'pleasantHill',
  PleasantValley = 'pleasantValley',
  Pleasanton = 'pleasanton',
  PlumGrove = 'plumGrove',
  PointBlank = 'pointBlank',
  PointComfort = 'pointComfort',
  PointVenture = 'pointVenture',
  Ponder = 'ponder',
  PortAlto = 'portAlto',
  PortAransas = 'portAransas',
  PortArthur = 'portArthur',
  PortIsabel = 'portIsabel',
  PortLavaca = 'portLavaca',
  PortMansfield = 'portMansfield',
  PortNeches = 'portNeches',
  PortOConnor = 'portOConnor',
  PorterHeights = 'porterHeights',
  Portland = 'portland',
  Post = 'post',
  PostOakBendCity = 'postOakBendCity',
  Poteet = 'poteet',
  Poth = 'poth',
  Potosi = 'potosi',
  Pottsboro = 'pottsboro',
  Powderly = 'powderly',
  Powell = 'powell',
  Poynor = 'poynor',
  PradoVerde = 'pradoVerde',
  PrairieHill = 'prairieHill',
  PrairieLea = 'prairieLea',
  Premont = 'premont',
  Presidio = 'presidio',
  Preston = 'preston',
  Primera = 'primera',
  Princeton = 'princeton',
  Progreso = 'progreso',
  ProgresoLakes = 'progresoLakes',
  Prosper = 'prosper',
  ProvidenceVillage = 'providenceVillage',
  PuebloEast = 'puebloEast',
  PuebloNuevo = 'puebloNuevo',
  Purmela = 'purmela',
  Putnam = 'putnam',
  Pyote = 'pyote',
  Quail = 'quail',
  QuailCreek = 'quailCreek',
  Quanah = 'quanah',
  QueenCity = 'queenCity',
  Quemado = 'quemado',
  Quesada = 'quesada',
  Quinlan = 'quinlan',
  Quintana = 'quintana',
  Quitaque = 'quitaque',
  Quitman = 'quitman',
  RadarBase = 'radarBase',
  RafaelPena = 'rafaelPena',
  Ralls = 'ralls',
  Ramireno = 'ramireno',
  RamirezPerez = 'ramirezPerez',
  Ramos = 'ramos',
  RanchetteeStates = 'ranchetteeStates',
  RanchitosDelNorte = 'ranchitosDelNorte',
  RanchitosEast = 'ranchitosEast',
  RanchitosLasLomas = 'ranchitosLasLomas',
  RanchoAlegre = 'ranchoAlegre',
  RanchoBanquete = 'ranchoBanquete',
  RanchoChico = 'ranchoChico',
  RanchoViejo = 'ranchoViejo',
  RanchosPenitasWest = 'ranchosPenitasWest',
  RandolphAFB = 'randolphAFB',
  Ranger = 'ranger',
  Rangerville = 'rangerville',
  Rankin = 'rankin',
  RansomCanyon = 'ransomCanyon',
  Ratamosa = 'ratamosa',
  Ravenna = 'ravenna',
  Raymondville = 'raymondville',
  Reagan = 'reagan',
  Realitos = 'realitos',
  RedLick = 'redLick',
  RedOak = 'redOak',
  RedRock = 'redRock',
  Redfield = 'redfield',
  Redford = 'redford',
  Redland = 'redland',
  Redwater = 'redwater',
  Redwood = 'redwood',
  Reedville = 'reedville',
  Refugio = 'refugio',
  ReginoRamirez = 'reginoRamirez',
  ReidHopeKing = 'reidHopeKing',
  Reklaw = 'reklaw',
  Relampago = 'relampago',
  Rendon = 'rendon',
  Reno = 'reno',
  Retreat = 'retreat',
  Rhome = 'rhome',
  Ricardo = 'ricardo',
  Rice = 'rice',
  Richardson = 'richardson',
  Richland = 'richland',
  RichlandHills = 'richlandHills',
  RichlandSprings = 'richlandSprings',
  Richmond = 'richmond',
  Richwood = 'richwood',
  Riesel = 'riesel',
  RioBravo = 'rioBravo',
  RioGrandeCity = 'rioGrandeCity',
  RioHondo = 'rioHondo',
  RioVista = 'rioVista',
  RisingStar = 'risingStar',
  RiverOaks = 'riverOaks',
  Rivereno = 'rivereno',
  Riverside = 'riverside',
  Riviera = 'riviera',
  Roanoke = 'roanoke',
  RoaringSprings = 'roaringSprings',
  RobertLee = 'robertLee',
  Robinson = 'robinson',
  Robstown = 'robstown',
  Roby = 'roby',
  Rochester = 'rochester',
  Rockdale = 'rockdale',
  Rockport = 'rockport',
  Rocksprings = 'rocksprings',
  Rockwall = 'rockwall',
  RockyMound = 'rockyMound',
  Rogers = 'rogers',
  Rollingwood = 'rollingwood',
  Roma = 'roma',
  RomaCreek = 'romaCreek',
  RomanForest = 'romanForest',
  Ropesville = 'ropesville',
  Rosanky = 'rosanky',
  Roscoe = 'roscoe',
  RoseCity = 'roseCity',
  RoseHillAcres = 'roseHillAcres',
  Rosebud = 'rosebud',
  Rosenberg = 'rosenberg',
  Rosharon = 'rosharon',
  Rosita = 'rosita',
  Ross = 'ross',
  Rosser = 'rosser',
  Rotan = 'rotan',
  RoundMountain = 'roundMountain',
  RoundRock = 'roundRock',
  RoundTop = 'roundTop',
  Rowlett = 'rowlett',
  Roxton = 'roxton',
  RoyseCity = 'royseCity',
  Rule = 'rule',
  RunawayBay = 'runawayBay',
  Runge = 'runge',
  Rusk = 'rusk',
  Sabinal = 'sabinal',
  Sachse = 'sachse',
  Sadler = 'sadler',
  Saginaw = 'saginaw',
  SaintHedwig = 'saintHedwig',
  Salado = 'salado',
  Salineño = 'salineño',
  SalineñoNorth = 'salineñoNorth',
  SamRayburn = 'samRayburn',
  SammyMartinez = 'sammyMartinez',
  Samnorwood = 'samnorwood',
  SanAngelo = 'sanAngelo',
  SanAntonio = 'sanAntonio',
  SanAugustine = 'sanAugustine',
  SanBenito = 'sanBenito',
  SanCarlos = 'sanCarlos',
  SanCarlosI = 'sanCarlosI',
  SanCarlosII = 'sanCarlosII',
  SanDiego = 'sanDiego',
  SanElizario = 'sanElizario',
  SanFelipe = 'sanFelipe',
  SanFernando = 'sanFernando',
  SanIsidro = 'sanIsidro',
  SanJuan = 'sanJuan',
  SanLeanna = 'sanLeanna',
  SanLeon = 'sanLeon',
  SanMarcos = 'sanMarcos',
  SanPatricio = 'sanPatricio',
  SanPedro = 'sanPedro',
  SanPerlita = 'sanPerlita',
  SanSaba = 'sanSaba',
  SanYgnacio = 'sanYgnacio',
  Sanctuary = 'sanctuary',
  SandSprings = 'sandSprings',
  Sanderson = 'sanderson',
  Sandia = 'sandia',
  Sandoval = 'sandoval',
  SandyHollowEscondidas = 'sandyHollowEscondidas',
  SandyPoint = 'sandyPoint',
  Sanford = 'sanford',
  Sanger = 'sanger',
  SansomPark = 'sansomPark',
  SantaAnna = 'santaAnna',
  SantaClara = 'santaClara',
  SantaCruz = 'santaCruz',
  SantaFe = 'santaFe',
  SantaMaria = 'santaMaria',
  SantaMonica = 'santaMonica',
  SantaRosa = 'santaRosa',
  Santel = 'santel',
  Sarita = 'sarita',
  Savannah = 'savannah',
  Savoy = 'savoy',
  ScenicOaks = 'scenicOaks',
  Schertz = 'schertz',
  Schroeder = 'schroeder',
  Schulenburg = 'schulenburg',
  Schwertner = 'schwertner',
  Scissors = 'scissors',
  Scotland = 'scotland',
  Scottsville = 'scottsville',
  Scurry = 'scurry',
  Seabrook = 'seabrook',
  Seadrift = 'seadrift',
  Seagoville = 'seagoville',
  Seagraves = 'seagraves',
  Sealy = 'sealy',
  Sebastian = 'sebastian',
  SecoMines = 'secoMines',
  Seguin = 'seguin',
  Selma = 'selma',
  Seminole = 'seminole',
  Serenada = 'serenada',
  SethWard = 'sethWard',
  SevenOaks = 'sevenOaks',
  SevenPoints = 'sevenPoints',
  Seymour = 'seymour',
  ShadyHollow = 'shadyHollow',
  ShadyShores = 'shadyShores',
  Shadybrook = 'shadybrook',
  Shallowater = 'shallowater',
  Shamrock = 'shamrock',
  ShavanoPark = 'shavanoPark',
  Sheldon = 'sheldon',
  Shenandoah = 'shenandoah',
  Shepherd = 'shepherd',
  Sheridan = 'sheridan',
  Sherman = 'sherman',
  SherwoodShores = 'sherwoodShores',
  Shiner = 'shiner',
  Shoreacres = 'shoreacres',
  SiennaPlantation = 'siennaPlantation',
  SierraBlanca = 'sierraBlanca',
  SiestaAcres = 'siestaAcres',
  SiestaShores = 'siestaShores',
  Silsbee = 'silsbee',
  Silverton = 'silverton',
  Simonton = 'simonton',
  Sinton = 'sinton',
  Skellytown = 'skellytown',
  Skidmore = 'skidmore',
  Slaton = 'slaton',
  Smiley = 'smiley',
  Smithville = 'smithville',
  Smyer = 'smyer',
  Snook = 'snook',
  Snyder = 'snyder',
  Socorro = 'socorro',
  Solis = 'solis',
  Somerset = 'somerset',
  Somerville = 'somerville',
  Sonora = 'sonora',
  SourLake = 'sourLake',
  SouthAlamo = 'southAlamo',
  SouthForkeStates = 'southForkeStates',
  SouthHouston = 'southHouston',
  SouthLaPaloma = 'southLaPaloma',
  SouthMountain = 'southMountain',
  SouthPadreIsland = 'southPadreIsland',
  SouthPoint = 'southPoint',
  SouthToledoBend = 'southToledoBend',
  Southlake = 'southlake',
  Southmayd = 'southmayd',
  SouthsidePlace = 'southsidePlace',
  Spade = 'spade',
  Sparks = 'sparks',
  Spearman = 'spearman',
  Spicewood = 'spicewood',
  Splendora = 'splendora',
  Spofford = 'spofford',
  Spring = 'spring',
  SpringBranch = 'springBranch',
  SpringGardens = 'springGardens',
  SpringValleyVillage = 'springValleyVillage',
  Springlake = 'springlake',
  Springtown = 'springtown',
  Spur = 'spur',
  StJo = 'stJo',
  StPaul = 'stPaul',
  Stafford = 'stafford',
  Stagecoach = 'stagecoach',
  Stairtown = 'stairtown',
  Stamford = 'stamford',
  Stanton = 'stanton',
  Staples = 'staples',
  StarHarbor = 'starHarbor',
  Stephenville = 'stephenville',
  SterlingCity = 'sterlingCity',
  Stinnett = 'stinnett',
  Stockdale = 'stockdale',
  Stonewall = 'stonewall',
  Stowell = 'stowell',
  Stratford = 'stratford',
  Strawn = 'strawn',
  Streetman = 'streetman',
  StudyButte = 'studyButte',
  Sublime = 'sublime',
  Sudan = 'sudan',
  SugarLand = 'sugarLand',
  SullivanCity = 'sullivanCity',
  SulphurSprings = 'sulphurSprings',
  SunValley = 'sunValley',
  Sundown = 'sundown',
  Sunnyvale = 'sunnyvale',
  Sunray = 'sunray',
  SunriseBeach = 'sunriseBeach',
  SunriseBeachVillage = 'sunriseBeachVillage',
  Sunset = 'sunset',
  SunsetAcres = 'sunsetAcres',
  SunsetValley = 'sunsetValley',
  SurfsideBeach = 'surfsideBeach',
  SutherlandSprings = 'sutherlandSprings',
  Sweeny = 'sweeny',
  SweetHome = 'sweetHome',
  Sweetwater = 'sweetwater',
  Taft = 'taft',
  TaftSouthwest = 'taftSouthwest',
  Tahoka = 'tahoka',
  Talco = 'talco',
  Talty = 'talty',
  TanquecitosSouthAcres = 'tanquecitosSouthAcres',
  TanquecitosSouthAcresII = 'tanquecitosSouthAcresII',
  Tatum = 'tatum',
  Taylor = 'taylor',
  TaylorLakeVillage = 'taylorLakeVillage',
  TaylorLanding = 'taylorLanding',
  Teague = 'teague',
  Tehuacana = 'tehuacana',
  Telferner = 'telferner',
  Temple = 'temple',
  Tenaha = 'tenaha',
  TennesseeColony = 'tennesseeColony',
  Terlingua = 'terlingua',
  Terrell = 'terrell',
  TerrellHills = 'terrellHills',
  Texarkana = 'texarkana',
  TexasCity = 'texasCity',
  Texhoma = 'texhoma',
  Texline = 'texline',
  TheColony = 'theColony',
  TheHills = 'theHills',
  TheWoodlands = 'theWoodlands',
  Thomaston = 'thomaston',
  Thompsons = 'thompsons',
  Thompsonville = 'thompsonville',
  Thorndale = 'thorndale',
  Thornton = 'thornton',
  Thorntonville = 'thorntonville',
  Thrall = 'thrall',
  ThreeRivers = 'threeRivers',
  Throckmorton = 'throckmorton',
  ThunderbirdBay = 'thunderbirdBay',
  TierraBonita = 'tierraBonita',
  TierraDorada = 'tierraDorada',
  TierraGrande = 'tierraGrande',
  TierraVerde = 'tierraVerde',
  TikiIsland = 'tikiIsland',
  Tilden = 'tilden',
  TimbercreekCanyon = 'timbercreekCanyon',
  TimberwoodPark = 'timberwoodPark',
  Timpson = 'timpson',
  Tioga = 'tioga',
  Tira = 'tira',
  Tivoli = 'tivoli',
  Toco = 'toco',
  ToddMission = 'toddMission',
  Tolar = 'tolar',
  TomBean = 'tomBean',
  Tomball = 'tomball',
  Tool = 'tool',
  Topsey = 'topsey',
  Tornillo = 'tornillo',
  Tow = 'tow',
  Toyah = 'toyah',
  Tradewinds = 'tradewinds',
  TravisRanch = 'travisRanch',
  Trent = 'trent',
  Trenton = 'trenton',
  Trinidad = 'trinidad',
  Trinity = 'trinity',
  TrophyClub = 'trophyClub',
  Troup = 'troup',
  Troy = 'troy',
  Tuleta = 'tuleta',
  Tulia = 'tulia',
  Tulsita = 'tulsita',
  Turkey = 'turkey',
  Tuscola = 'tuscola',
  Tye = 'tye',
  Tyler = 'tyler',
  Tynan = 'tynan',
  Uhland = 'uhland',
  UnionGrove = 'unionGrove',
  UnionValley = 'unionValley',
  UniversalCity = 'universalCity',
  UniversityPark = 'universityPark',
  Utopia = 'utopia',
  Uvalde = 'uvalde',
  UvaldeeStates = 'uvaldeeStates',
  ValVerdePark = 'valVerdePark',
  Valentine = 'valentine',
  ValleHermoso = 'valleHermoso',
  ValleVerde = 'valleVerde',
  ValleVista = 'valleVista',
  ValleyMills = 'valleyMills',
  ValleyView = 'valleyView',
  Van = 'van',
  VanAlstyne = 'vanAlstyne',
  VanHorn = 'vanHorn',
  VanVleck = 'vanVleck',
  Vanderbilt = 'vanderbilt',
  Vanderpool = 'vanderpool',
  Vega = 'vega',
  Venture = 'venture',
  Venus = 'venus',
  Vernon = 'vernon',
  Victoria = 'victoria',
  VictoriaVera = 'victoriaVera',
  Vidor = 'vidor',
  VillaDelSol = 'villaDelSol',
  VillaPancho = 'villaPancho',
  VillaVerde = 'villaVerde',
  Villarreal = 'villarreal',
  Vinton = 'vinton',
  Volente = 'volente',
  VonOrmy = 'vonOrmy',
  Waco = 'waco',
  Waelder = 'waelder',
  WakeVillage = 'wakeVillage',
  Waller = 'waller',
  Wallis = 'wallis',
  WalnutSprings = 'walnutSprings',
  Warren = 'warren',
  WarrenCity = 'warrenCity',
  Warrenton = 'warrenton',
  Washington = 'washington',
  Waskom = 'waskom',
  Watauga = 'watauga',
  Waxahachie = 'waxahachie',
  Weatherford = 'weatherford',
  Webberville = 'webberville',
  Webster = 'webster',
  Weesatche = 'weesatche',
  Weimar = 'weimar',
  Weinert = 'weinert',
  Weir = 'weir',
  Welch = 'welch',
  Wellington = 'wellington',
  Wellman = 'wellman',
  Wells = 'wells',
  WellsBranch = 'wellsBranch',
  Weslaco = 'weslaco',
  West = 'west',
  WestAltoBonito = 'westAltoBonito',
  WestColumbia = 'westColumbia',
  WestLakeHills = 'westLakeHills',
  WestLivingston = 'westLivingston',
  WestOdessa = 'westOdessa',
  WestOrange = 'westOrange',
  WestSharyland = 'westSharyland',
  WestTawakoni = 'westTawakoni',
  WestUniversityPlace = 'westUniversityPlace',
  Westbrook = 'westbrook',
  Westdale = 'westdale',
  WesternLake = 'westernLake',
  Westhoff = 'westhoff',
  Westlake = 'westlake',
  Westminster = 'westminster',
  Weston = 'weston',
  WestonLakes = 'westonLakes',
  WestoverHills = 'westoverHills',
  Westphalia = 'westphalia',
  Westway = 'westway',
  WestwoodShores = 'westwoodShores',
  WestworthVillage = 'westworthVillage',
  Wharton = 'wharton',
  Wheeler = 'wheeler',
  WhiteDeer = 'whiteDeer',
  WhiteOak = 'whiteOak',
  WhiteSettlement = 'whiteSettlement',
  Whiteface = 'whiteface',
  Whitehouse = 'whitehouse',
  Whitesboro = 'whitesboro',
  Whitewright = 'whitewright',
  Whitney = 'whitney',
  Whitsett = 'whitsett',
  WichitaFalls = 'wichitaFalls',
  Wickett = 'wickett',
  WildPeachVillage = 'wildPeachVillage',
  Wildwood = 'wildwood',
  Willis = 'willis',
  WillowPark = 'willowPark',
  WillsPoint = 'willsPoint',
  Wilmer = 'wilmer',
  Wilson = 'wilson',
  Wimberley = 'wimberley',
  Windcrest = 'windcrest',
  Windemere = 'windemere',
  Windom = 'windom',
  Windthorst = 'windthorst',
  Winfield = 'winfield',
  Wink = 'wink',
  Winnie = 'winnie',
  Winnsboro = 'winnsboro',
  Winona = 'winona',
  Winters = 'winters',
  WixonValley = 'wixonValley',
  WolfeCity = 'wolfeCity',
  Wolfforth = 'wolfforth',
  WoodHi = 'woodHi',
  Woodbranch = 'woodbranch',
  Woodcreek = 'woodcreek',
  Woodloch = 'woodloch',
  Woodsboro = 'woodsboro',
  Woodson = 'woodson',
  Woodville = 'woodville',
  Woodway = 'woodway',
  Wortham = 'wortham',
  Wrightsboro = 'wrightsboro',
  Wyldwood = 'wyldwood',
  Wylie = 'wylie',
  Yantis = 'yantis',
  Yoakum = 'yoakum',
  Yorktown = 'yorktown',
  Youngsport = 'youngsport',
  Yznaga = 'yznaga',
  Zapata = 'zapata',
  ZapataRanch = 'zapataRanch',
  Zarate = 'zarate',
  Zavalla = 'zavalla',
  Zuehl = 'zuehl'
}

export const CtxCitiesLabel: Record<CtxCities, string> = {
  [CtxCities.Abbott]: 'Abbott',
  [CtxCities.Abernathy]: 'Abernathy',
  [CtxCities.Abilene]: 'Abilene',
  [CtxCities.Abram]: 'Abram',
  [CtxCities.Ackerly]: 'Ackerly',
  [CtxCities.Adamsville]: 'Adamsville',
  [CtxCities.Addison]: 'Addison',
  [CtxCities.Adkins]: 'Adkins',
  [CtxCities.Adrian]: 'Adrian',
  [CtxCities.AguaDulce]: 'Agua Dulce',
  [CtxCities.Aguilares]: 'Aguilares',
  [CtxCities.AirportHeights]: 'Airport Heights',
  [CtxCities.AirportRoadAddition]: 'Airport Road Addition',
  [CtxCities.AlamoHeights]: 'Alamo Heights',
  [CtxCities.Alba]: 'Alba',
  [CtxCities.Albany]: 'Albany',
  [CtxCities.Aldine]: 'Aldine',
  [CtxCities.Aledo]: 'Aledo',
  [CtxCities.Alfred]: 'Alfred',
  [CtxCities.Alice]: 'Alice',
  [CtxCities.AliceAcres]: 'Alice Acres',
  [CtxCities.Allen]: 'Allen',
  [CtxCities.Alleyton]: 'Alleyton',
  [CtxCities.Alma]: 'Alma',
  [CtxCities.Alpine]: 'Alpine',
  [CtxCities.Alto]: 'Alto',
  [CtxCities.AltoBonitoHeights]: 'Alto Bonito Heights',
  [CtxCities.Alton]: 'Alton',
  [CtxCities.Alvarado]: 'Alvarado',
  [CtxCities.Alvin]: 'Alvin',
  [CtxCities.Alvord]: 'Alvord',
  [CtxCities.AmadaAcres]: 'Amada Acres',
  [CtxCities.Amargosa]: 'Amargosa',
  [CtxCities.Amaya]: 'Amaya',
  [CtxCities.Ames]: 'Ames',
  [CtxCities.Amherst]: 'Amherst',
  [CtxCities.Amistad]: 'Amistad',
  [CtxCities.Anacua]: 'Anacua',
  [CtxCities.Anahuac]: 'Anahuac',
  [CtxCities.Anderson]: 'Anderson',
  [CtxCities.Andice]: 'Andice',
  [CtxCities.Andrews]: 'Andrews',
  [CtxCities.Angleton]: 'Angleton',
  [CtxCities.Angus]: 'Angus',
  [CtxCities.Anna]: 'Anna',
  [CtxCities.Annetta]: 'Annetta',
  [CtxCities.AnnettaNorth]: 'Annetta North',
  [CtxCities.AnnettaSouth]: 'Annetta South',
  [CtxCities.Annona]: 'Annona',
  [CtxCities.Anson]: 'Anson',
  [CtxCities.Anthony]: 'Anthony',
  [CtxCities.Anton]: 'Anton',
  [CtxCities.Appleby]: 'Appleby',
  [CtxCities.Aquilla]: 'Aquilla',
  [CtxCities.AransasPass]: 'Aransas Pass',
  [CtxCities.ArcherCity]: 'Archer City',
  [CtxCities.Arcola]: 'Arcola',
  [CtxCities.Argyle]: 'Argyle',
  [CtxCities.Arlington]: 'Arlington',
  [CtxCities.Arp]: 'Arp',
  [CtxCities.ArroyoColoradoeStates]: 'Arroyo Colorado eStates',
  [CtxCities.ArroyoGardens]: 'Arroyo Gardens',
  [CtxCities.Asherton]: 'Asherton',
  [CtxCities.Aspermont]: 'Aspermont',
  [CtxCities.Atascocita]: 'Atascocita',
  [CtxCities.Atascosa]: 'Atascosa',
  [CtxCities.Athens]: 'Athens',
  [CtxCities.Atlanta]: 'Atlanta',
  [CtxCities.Aubrey]: 'Aubrey',
  [CtxCities.Aurora]: 'Aurora',
  [CtxCities.Austin]: 'Austin',
  [CtxCities.Austwell]: 'Austwell',
  [CtxCities.Avery]: 'Avery',
  [CtxCities.Avinger]: 'Avinger',
  [CtxCities.Axtell]: 'Axtell',
  [CtxCities.Azle]: 'Azle',
  [CtxCities.Bacliff]: 'Bacliff',
  [CtxCities.Bailey]: 'Bailey',
  [CtxCities.BaileysPrairie]: 'Bailey"s Prairie',
  [CtxCities.Baird]: 'Baird',
  [CtxCities.BalchSprings]: 'Balch Springs',
  [CtxCities.BalconesHeights]: 'Balcones Heights',
  [CtxCities.Ballinger]: 'Ballinger',
  [CtxCities.Balmorhea]: 'Balmorhea',
  [CtxCities.Bandera]: 'Bandera',
  [CtxCities.Bangs]: 'Bangs',
  [CtxCities.Banquete]: 'Banquete',
  [CtxCities.Barclay]: 'Barclay',
  [CtxCities.Bardwell]: 'Bardwell',
  [CtxCities.Barrera]: 'Barrera',
  [CtxCities.Barrett]: 'Barrett',
  [CtxCities.Barry]: 'Barry',
  [CtxCities.Barstow]: 'Barstow',
  [CtxCities.Bartlett]: 'Bartlett',
  [CtxCities.BartonCreek]: 'Barton Creek',
  [CtxCities.Bartonville]: 'Bartonville',
  [CtxCities.Bastrop]: 'Bastrop',
  [CtxCities.Batesville]: 'Batesville',
  [CtxCities.BayCity]: 'Bay City',
  [CtxCities.BayouVista]: 'Bayou Vista',
  [CtxCities.Bayside]: 'Bayside',
  [CtxCities.Baytown]: 'Baytown',
  [CtxCities.Bayview]: 'Bayview',
  [CtxCities.BeachCity]: 'Beach City',
  [CtxCities.BearCreek]: 'Bear Creek',
  [CtxCities.Beasley]: 'Beasley',
  [CtxCities.Beaumont]: 'Beaumont',
  [CtxCities.Bebe]: 'Bebe',
  [CtxCities.Beckville]: 'Beckville',
  [CtxCities.Bedford]: 'Bedford',
  [CtxCities.Bedias]: 'Bedias',
  [CtxCities.BeeCave]: 'Bee Cave',
  [CtxCities.Beeville]: 'Beeville',
  [CtxCities.Bellaire]: 'Bellaire',
  [CtxCities.Bellevue]: 'Bellevue',
  [CtxCities.Bellfalls]: 'Bellfalls',
  [CtxCities.Bellmead]: 'Bellmead',
  [CtxCities.Bells]: 'Bells',
  [CtxCities.Bellville]: 'Bellville',
  [CtxCities.Belmont]: 'Belmont',
  [CtxCities.Belton]: 'Belton',
  [CtxCities.Benavides]: 'Benavides',
  [CtxCities.Benbrook]: 'Benbrook',
  [CtxCities.Bend]: 'Bend',
  [CtxCities.Benjamin]: 'Benjamin',
  [CtxCities.BenjaminPerez]: 'Benjamin Perez',
  [CtxCities.Berclair]: 'Berclair',
  [CtxCities.Bergheim]: 'Bergheim',
  [CtxCities.Berryville]: 'Berryville',
  [CtxCities.Bertram]: 'Bertram',
  [CtxCities.BeverlyHills]: 'Beverly Hills',
  [CtxCities.BevilOaks]: 'Bevil Oaks',
  [CtxCities.BigLake]: 'Big Lake',
  [CtxCities.BigSandy]: 'Big Sandy',
  [CtxCities.BigSpring]: 'Big Spring',
  [CtxCities.BigThicketLakeeStates]: 'Big Thicket Lake eStates',
  [CtxCities.BigWells]: 'Big Wells',
  [CtxCities.Bigfoot]: 'Bigfoot',
  [CtxCities.BishopHills]: 'Bishop Hills',
  [CtxCities.Bixby]: 'Bixby',
  [CtxCities.Blackwell]: 'Blackwell',
  [CtxCities.Blanco]: 'Blanco',
  [CtxCities.Blanket]: 'Blanket',
  [CtxCities.Blessing]: 'Blessing',
  [CtxCities.Bloomburg]: 'Bloomburg',
  [CtxCities.BloomingGrove]: 'Blooming Grove',
  [CtxCities.Bloomington]: 'Bloomington',
  [CtxCities.Blossom]: 'Blossom',
  [CtxCities.BlueBerryHill]: 'Blue Berry Hill',
  [CtxCities.BlueMound]: 'Blue Mound',
  [CtxCities.BlueRidge]: 'Blue Ridge',
  [CtxCities.Bluetown]: 'Bluetown',
  [CtxCities.Blum]: 'Blum',
  [CtxCities.Boerne]: 'Boerne',
  [CtxCities.Bogata]: 'Bogata',
  [CtxCities.Boling]: 'Boling',
  [CtxCities.BolivarPeninsula]: 'Bolivar Peninsula',
  [CtxCities.BonanzaHills]: 'Bonanza Hills',
  [CtxCities.Bonham]: 'Bonham',
  [CtxCities.Bonney]: 'Bonney',
  [CtxCities.Booker]: 'Booker',
  [CtxCities.Borger]: 'Borger',
  [CtxCities.Botines]: 'Botines',
  [CtxCities.Bovina]: 'Bovina',
  [CtxCities.Bowie]: 'Bowie',
  [CtxCities.BoxCanyon]: 'Box Canyon',
  [CtxCities.Boyd]: 'Boyd',
  [CtxCities.BoysRanch]: 'Boys Ranch',
  [CtxCities.Bracken]: 'Bracken',
  [CtxCities.Brackettville]: 'Brackettville',
  [CtxCities.Brady]: 'Brady',
  [CtxCities.Brandon]: 'Brandon',
  [CtxCities.Brazoria]: 'Brazoria',
  [CtxCities.BrazosBend]: 'Brazos Bend',
  [CtxCities.BrazosCountry]: 'Brazos Country',
  [CtxCities.Breckenridge]: 'Breckenridge',
  [CtxCities.Bremond]: 'Bremond',
  [CtxCities.Brenham]: 'Brenham',
  [CtxCities.Briar]: 'Briar',
  [CtxCities.Briarcliff]: 'Briarcliff',
  [CtxCities.Briaroaks]: 'Briaroaks',
  [CtxCities.BridgeCity]: 'Bridge City',
  [CtxCities.Bridgeport]: 'Bridgeport',
  [CtxCities.Briggs]: 'Briggs',
  [CtxCities.Bristol]: 'Bristol',
  [CtxCities.Broaddus]: 'Broaddus',
  [CtxCities.Bronte]: 'Bronte',
  [CtxCities.Brookshire]: 'Brookshire',
  [CtxCities.BrooksideVillage]: 'Brookside Village',
  [CtxCities.Browndell]: 'Browndell',
  [CtxCities.Brownfield]: 'Brownfield',
  [CtxCities.Brownsboro]: 'Brownsboro',
  [CtxCities.Brownsville]: 'Brownsville',
  [CtxCities.Brownwood]: 'Brownwood',
  [CtxCities.BrucevilleEddy]: 'Bruceville-Eddy',
  [CtxCities.Brundage]: 'Brundage',
  [CtxCities.Bruni]: 'Bruni',
  [CtxCities.BrushyCreek]: 'Brushy Creek',
  [CtxCities.Bryan]: 'Bryan',
  [CtxCities.Bryson]: 'Bryson',
  [CtxCities.BuchananDam]: 'Buchanan Dam',
  [CtxCities.BuchananLakeVillage]: 'Buchanan Lake Village',
  [CtxCities.Buckholts]: 'Buckholts',
  [CtxCities.Buda]: 'Buda',
  [CtxCities.BuenaVista]: 'Buena Vista',
  [CtxCities.Buffalo]: 'Buffalo',
  [CtxCities.BuffaloGap]: 'Buffalo Gap',
  [CtxCities.BuffaloSprings]: 'Buffalo Springs',
  [CtxCities.Bullard]: 'Bullard',
  [CtxCities.Bulverde]: 'Bulverde',
  [CtxCities.Buna]: 'Buna',
  [CtxCities.BunkerHillVillage]: 'Bunker Hill Village',
  [CtxCities.Burkburnett]: 'Burkburnett',
  [CtxCities.Burke]: 'Burke',
  [CtxCities.Burleson]: 'Burleson',
  [CtxCities.Burlington]: 'Burlington',
  [CtxCities.Burnet]: 'Burnet',
  [CtxCities.Burton]: 'Burton',
  [CtxCities.Butterfield]: 'Butterfield',
  [CtxCities.Byers]: 'Byers',
  [CtxCities.Bynum]: 'Bynum',
  [CtxCities.Cactus]: 'Cactus',
  [CtxCities.CaddoMills]: 'Caddo Mills',
  [CtxCities.Caldwell]: 'Caldwell',
  [CtxCities.CallenderLake]: 'Callender Lake',
  [CtxCities.Callisburg]: 'Callisburg',
  [CtxCities.Calvert]: 'Calvert',
  [CtxCities.Camargito]: 'Camargito',
  [CtxCities.Cameron]: 'Cameron',
  [CtxCities.CameronPark]: 'Cameron Park',
  [CtxCities.CampSwift]: 'Camp Swift',
  [CtxCities.CampWood]: 'Camp Wood',
  [CtxCities.Campbell]: 'Campbell',
  [CtxCities.CampoVerde]: 'Campo Verde',
  [CtxCities.Canadian]: 'Canadian',
  [CtxCities.CaneyCity]: 'Caney City',
  [CtxCities.Canton]: 'Canton',
  [CtxCities.CantuAddition]: 'Cantu Addition',
  [CtxCities.Canutillo]: 'Canutillo',
  [CtxCities.Canyon]: 'Canyon',
  [CtxCities.CanyonCreek]: 'Canyon Creek',
  [CtxCities.CanyonLake]: 'Canyon Lake',
  [CtxCities.CapeRoyale]: 'Cape Royale',
  [CtxCities.Carbon]: 'Carbon',
  [CtxCities.CarlsCorner]: 'Carl"s Corner',
  [CtxCities.Carlsbad]: 'Carlsbad',
  [CtxCities.Carmine]: 'Carmine',
  [CtxCities.CarrizoHill]: 'Carrizo Hill',
  [CtxCities.CarrizoSprings]: 'Carrizo Springs',
  [CtxCities.Carrollton]: 'Carrollton',
  [CtxCities.Carthage]: 'Carthage',
  [CtxCities.CasaBlanca]: 'Casa Blanca',
  [CtxCities.Casas]: 'Casas',
  [CtxCities.CashionCommunity]: 'Cashion Community',
  [CtxCities.CastleHills]: 'Castle Hills',
  [CtxCities.Castroville]: 'Castroville',
  [CtxCities.Catarina]: 'Catarina',
  [CtxCities.CedarCreek]: 'Cedar Creek',
  [CtxCities.CedarHill]: 'Cedar Hill',
  [CtxCities.CedarPark]: 'Cedar Park',
  [CtxCities.CedarPoint]: 'Cedar Point',
  [CtxCities.Celeste]: 'Celeste',
  [CtxCities.Celina]: 'Celina',
  [CtxCities.CensusPlaceName]: 'census_place_name',
  [CtxCities.Center]: 'Center',
  [CtxCities.Centerville]: 'Centerville',
  [CtxCities.CentralGardens]: 'Central Gardens',
  [CtxCities.CesarChavez]: 'César Chávez',
  [CtxCities.Chandler]: 'Chandler',
  [CtxCities.Channelview]: 'Channelview',
  [CtxCities.Channing]: 'Channing',
  [CtxCities.Chaparrito]: 'Chaparrito',
  [CtxCities.Chapeno]: 'Chapeno',
  [CtxCities.Charlotte]: 'Charlotte',
  [CtxCities.Chester]: 'Chester',
  [CtxCities.Chico]: 'Chico',
  [CtxCities.Childress]: 'Childress',
  [CtxCities.Chillicothe]: 'Chillicothe',
  [CtxCities.Chilton]: 'Chilton',
  [CtxCities.China]: 'China',
  [CtxCities.ChinaGrove]: 'China Grove',
  [CtxCities.ChinaSpring]: 'China Spring',
  [CtxCities.Chireno]: 'Chireno',
  [CtxCities.Christine]: 'Christine',
  [CtxCities.Christoval]: 'Christoval',
  [CtxCities.ChulaVista]: 'Chula Vista',
  [CtxCities.Cibolo]: 'Cibolo',
  [CtxCities.CienegasTerrace]: 'Cienegas Terrace',
  [CtxCities.CincoRanch]: 'Cinco Ranch',
  [CtxCities.CircleDKceStates]: 'Circle D-KC eStates',
  [CtxCities.Cisco]: 'Cisco',
  [CtxCities.CitrusCity]: 'Citrus City',
  [CtxCities.Clarendon]: 'Clarendon',
  [CtxCities.Clarksville]: 'Clarksville',
  [CtxCities.ClarksvilleCity]: 'Clarksville City',
  [CtxCities.Claude]: 'Claude',
  [CtxCities.ClearLakeShores]: 'Clear Lake Shores',
  [CtxCities.Cleburne]: 'Cleburne',
  [CtxCities.Cleveland]: 'Cleveland',
  [CtxCities.Clifton]: 'Clifton',
  [CtxCities.Clint]: 'Clint',
  [CtxCities.Cloverleaf]: 'Cloverleaf',
  [CtxCities.Clute]: 'Clute',
  [CtxCities.Clyde]: 'Clyde',
  [CtxCities.Coahoma]: 'Coahoma',
  [CtxCities.CockrellHill]: 'Cockrell Hill',
  [CtxCities.CoffeeCity]: 'Coffee City',
  [CtxCities.Coldspring]: 'Coldspring',
  [CtxCities.Coleman]: 'Coleman',
  [CtxCities.CollegeStation]: 'College Station',
  [CtxCities.Colleyville]: 'Colleyville',
  [CtxCities.Collinsville]: 'Collinsville',
  [CtxCities.Colmesneil]: 'Colmesneil',
  [CtxCities.ColoradoAcres]: 'Colorado Acres',
  [CtxCities.ColoradoCity]: 'Colorado City',
  [CtxCities.Columbus]: 'Columbus',
  [CtxCities.Comanche]: 'Comanche',
  [CtxCities.Combes]: 'Combes',
  [CtxCities.Combine]: 'Combine',
  [CtxCities.Comfort]: 'Comfort',
  [CtxCities.Commerce]: 'Commerce',
  [CtxCities.Como]: 'Como',
  [CtxCities.Concan]: 'Concan',
  [CtxCities.Concepcion]: 'Concepcion',
  [CtxCities.Conroe]: 'Conroe',
  [CtxCities.Converse]: 'Converse',
  [CtxCities.Cool]: 'Cool',
  [CtxCities.Coolidge]: 'Coolidge',
  [CtxCities.Cooper]: 'Cooper',
  [CtxCities.Coppell]: 'Coppell',
  [CtxCities.CopperCanyon]: 'Copper Canyon',
  [CtxCities.CopperasCove]: 'Copperas Cove',
  [CtxCities.Corinth]: 'Corinth',
  [CtxCities.CorpusChristi]: 'Corpus Christi',
  [CtxCities.CorralCity]: 'Corral City',
  [CtxCities.Corrigan]: 'Corrigan',
  [CtxCities.Corsicana]: 'Corsicana',
  [CtxCities.Cost]: 'Cost',
  [CtxCities.Cottonwood]: 'Cottonwood',
  [CtxCities.CottonwoodShores]: 'Cottonwood Shores',
  [CtxCities.Cotulla]: 'Cotulla',
  [CtxCities.CountryAcres]: 'Country Acres',
  [CtxCities.Coupland]: 'Coupland',
  [CtxCities.Cove]: 'Cove',
  [CtxCities.Covington]: 'Covington',
  [CtxCities.Coyanosa]: 'Coyanosa',
  [CtxCities.CoyoteAcres]: 'Coyote Acres',
  [CtxCities.CoyoteFlats]: 'Coyote Flats',
  [CtxCities.Crandall]: 'Crandall',
  [CtxCities.Crane]: 'Crane',
  [CtxCities.CranfillsGap]: 'Cranfills Gap',
  [CtxCities.Crawford]: 'Crawford',
  [CtxCities.Creedmoor]: 'Creedmoor',
  [CtxCities.Cresson]: 'Cresson',
  [CtxCities.Crockett]: 'Crockett',
  [CtxCities.Crosby]: 'Crosby',
  [CtxCities.Crosbyton]: 'Crosbyton',
  [CtxCities.CrossMountain]: 'Cross Mountain',
  [CtxCities.CrossPlains]: 'Cross Plains',
  [CtxCities.CrossRoads]: 'Cross Roads',
  [CtxCities.CrossTimber]: 'Cross Timber',
  [CtxCities.Crowell]: 'Crowell',
  [CtxCities.Crowley]: 'Crowley',
  [CtxCities.CrystalCity]: 'Crystal City',
  [CtxCities.Cuero]: 'Cuero',
  [CtxCities.Cuevitas]: 'Cuevitas',
  [CtxCities.Cumby]: 'Cumby',
  [CtxCities.Cumings]: 'Cumings',
  [CtxCities.Cuney]: 'Cuney',
  [CtxCities.Cushing]: 'Cushing',
  [CtxCities.CutandShoot]: 'Cut and Shoot',
  [CtxCities.DHanis]: 'D"Hanis',
  [CtxCities.Daingerfield]: 'Daingerfield',
  [CtxCities.Daisetta]: 'Daisetta',
  [CtxCities.Dale]: 'Dale',
  [CtxCities.Dalhart]: 'Dalhart',
  [CtxCities.Dallas]: 'Dallas',
  [CtxCities.DalworthingtonGardens]: 'Dalworthington Gardens',
  [CtxCities.Damon]: 'Damon',
  [CtxCities.Danbury]: 'Danbury',
  [CtxCities.Darrouzett]: 'Darrouzett',
  [CtxCities.Dawson]: 'Dawson',
  [CtxCities.Dayton]: 'Dayton',
  [CtxCities.DaytonLakes]: 'Dayton Lakes',
  [CtxCities.DeKalb]: 'De Kalb',
  [CtxCities.DeLeon]: 'De Leon',
  [CtxCities.Dean]: 'Dean',
  [CtxCities.Decatur]: 'Decatur',
  [CtxCities.DeCordova]: 'DeCordova',
  [CtxCities.DeerPark]: 'Deer Park',
  [CtxCities.DelMarHeights]: 'Del Mar Heights',
  [CtxCities.DelRio]: 'Del Rio',
  [CtxCities.DelSol]: 'Del Sol',
  [CtxCities.DelValle]: 'Del Valle',
  [CtxCities.DellCity]: 'Dell City',
  [CtxCities.Delmita]: 'Delmita',
  [CtxCities.Denison]: 'Denison',
  [CtxCities.Denton]: 'Denton',
  [CtxCities.DenverCity]: 'Denver City',
  [CtxCities.Deport]: 'Deport',
  [CtxCities.Desdemona]: 'Desdemona',
  [CtxCities.DeSoto]: 'DeSoto',
  [CtxCities.Detroit]: 'Detroit',
  [CtxCities.Devers]: 'Devers',
  [CtxCities.Devine]: 'Devine',
  [CtxCities.Deweyville]: 'Deweyville',
  [CtxCities.Diboll]: 'Diboll',
  [CtxCities.Dickens]: 'Dickens',
  [CtxCities.Dickinson]: 'Dickinson',
  [CtxCities.Dilley]: 'Dilley',
  [CtxCities.Dimmitt]: 'Dimmitt',
  [CtxCities.DISH]: 'DISH',
  [CtxCities.DoddCity]: 'Dodd City',
  [CtxCities.Dodson]: 'Dodson',
  [CtxCities.Doffing]: 'Doffing',
  [CtxCities.Domino]: 'Domino',
  [CtxCities.Donie]: 'Donie',
  [CtxCities.Donna]: 'Donna',
  [CtxCities.Doolittle]: 'Doolittle',
  [CtxCities.Dorchester]: 'Dorchester',
  [CtxCities.DoubleOak]: 'Double Oak',
  [CtxCities.Douglassville]: 'Douglassville',
  [CtxCities.Doyle]: 'Doyle',
  [CtxCities.Driftwood]: 'Driftwood',
  [CtxCities.DrippingSprings]: 'Dripping Springs',
  [CtxCities.DrippingSpringsRanchRd]: 'Dripping Springs Ranch Rd',
  [CtxCities.Driscoll]: 'Driscoll',
  [CtxCities.Dublin]: 'Dublin',
  [CtxCities.Dumas]: 'Dumas',
  [CtxCities.Duncanville]: 'Duncanville',
  [CtxCities.EagleLake]: 'Eagle Lake',
  [CtxCities.EaglePass]: 'Eagle Pass',
  [CtxCities.Early]: 'Early',
  [CtxCities.Earth]: 'Earth',
  [CtxCities.EastAltoBonito]: 'East Alto Bonito',
  [CtxCities.EastBernard]: 'East Bernard',
  [CtxCities.EastLopez]: 'East Lopez',
  [CtxCities.EastMountain]: 'East Mountain',
  [CtxCities.EastTawakoni]: 'East Tawakoni',
  [CtxCities.Eastland]: 'Eastland',
  [CtxCities.Easton]: 'Easton',
  [CtxCities.Ector]: 'Ector',
  [CtxCities.Edcouch]: 'Edcouch',
  [CtxCities.Eddy]: 'Eddy',
  [CtxCities.Eden]: 'Eden',
  [CtxCities.EdgecliffVillage]: 'Edgecliff Village',
  [CtxCities.EdgewatereStates]: 'Edgewater eStates',
  [CtxCities.Edgewood]: 'Edgewood',
  [CtxCities.Edinburg]: 'Edinburg',
  [CtxCities.Edmonson]: 'Edmonson',
  [CtxCities.Edna]: 'Edna',
  [CtxCities.Edom]: 'Edom',
  [CtxCities.Edroy]: 'Edroy',
  [CtxCities.EidsonRoad]: 'Eidson Road',
  [CtxCities.ElBrazil]: 'El Brazil',
  [CtxCities.ElCaminoAngosto]: 'El Camino Angosto',
  [CtxCities.ElCampo]: 'El Campo',
  [CtxCities.ElCastillo]: 'El Castillo',
  [CtxCities.ElCenizo]: 'El Cenizo',
  [CtxCities.ElChaparral]: 'El Chaparral',
  [CtxCities.ElIndio]: 'El Indio',
  [CtxCities.ElLago]: 'El Lago',
  [CtxCities.ElMesquite]: 'El Mesquite',
  [CtxCities.ElPaso]: 'El Paso',
  [CtxCities.ElQuiote]: 'El Quiote',
  [CtxCities.ElRanchoVela]: 'El Rancho Vela',
  [CtxCities.ElRefugio]: 'El Refugio',
  [CtxCities.ElSocio]: 'El Socio',
  [CtxCities.ElToro]: 'El Toro',
  [CtxCities.Elbert]: 'Elbert',
  [CtxCities.Eldorado]: 'Eldorado',
  [CtxCities.Electra]: 'Electra',
  [CtxCities.Elgin]: 'Elgin',
  [CtxCities.EliasFelaSolis]: 'Elias-Fela Solis',
  [CtxCities.Elkhart]: 'Elkhart',
  [CtxCities.Ellinger]: 'Ellinger',
  [CtxCities.ElmCreek]: 'Elm Creek',
  [CtxCities.ElmMott]: 'Elm Mott',
  [CtxCities.Elmendorf]: 'Elmendorf',
  [CtxCities.Elmo]: 'Elmo',
  [CtxCities.Elsa]: 'Elsa',
  [CtxCities.EmeraldBay]: 'Emerald Bay',
  [CtxCities.Emhouse]: 'Emhouse',
  [CtxCities.Emory]: 'Emory',
  [CtxCities.EncantadaRanchitoElCalaboz]: 'Encantada-Ranchito El Calaboz',
  [CtxCities.EnchantedOaks]: 'Enchanted Oaks',
  [CtxCities.Encinal]: 'Encinal',
  [CtxCities.Encino]: 'Encino',
  [CtxCities.Ennis]: 'Ennis',
  [CtxCities.Escobares]: 'Escobares',
  [CtxCities.Estelline]: 'Estelline',
  [CtxCities.EugenioSaenz]: 'Eugenio Saenz',
  [CtxCities.Euless]: 'Euless',
  [CtxCities.Eureka]: 'Eureka',
  [CtxCities.Eustace]: 'Eustace',
  [CtxCities.Evadale]: 'Evadale',
  [CtxCities.Evant]: 'Evant',
  [CtxCities.Evergreen]: 'Evergreen',
  [CtxCities.Everman]: 'Everman',
  [CtxCities.Ezzell]: 'Ezzell',
  [CtxCities.Fabens]: 'Fabens',
  [CtxCities.Fabrica]: 'Fabrica',
  [CtxCities.FairOaksRanch]: 'Fair Oaks Ranch',
  [CtxCities.Fairchilds]: 'Fairchilds',
  [CtxCities.Fairfield]: 'Fairfield',
  [CtxCities.Fairview]: 'Fairview',
  [CtxCities.FalconHeights]: 'Falcon Heights',
  [CtxCities.FalconLakeeStates]: 'Falcon Lake eStates',
  [CtxCities.FalconMesa]: 'Falcon Mesa',
  [CtxCities.FalconVillage]: 'Falcon Village',
  [CtxCities.Falconaire]: 'Falconaire',
  [CtxCities.Falfurrias]: 'Falfurrias',
  [CtxCities.FallsCity]: 'Falls City',
  [CtxCities.Falman]: 'Falman',
  [CtxCities.Fannett]: 'Fannett',
  [CtxCities.Fannin]: 'Fannin',
  [CtxCities.FarmersBranch]: 'Farmers Branch',
  [CtxCities.Farmersville]: 'Farmersville',
  [CtxCities.Farwell]: 'Farwell',
  [CtxCities.Fate]: 'Fate',
  [CtxCities.Fayetteville]: 'Fayetteville',
  [CtxCities.Faysville]: 'Faysville',
  [CtxCities.Fentress]: 'Fentress',
  [CtxCities.FernandoSalinas]: 'Fernando Salinas',
  [CtxCities.Ferris]: 'Ferris',
  [CtxCities.FifthStreet]: 'Fifth Street',
  [CtxCities.Fischer]: 'Fischer',
  [CtxCities.Flat]: 'Flat',
  [CtxCities.Flatonia]: 'Flatonia',
  [CtxCities.FlordelRio]: 'Flor del Rio',
  [CtxCities.Florence]: 'Florence',
  [CtxCities.Floresville]: 'Floresville',
  [CtxCities.Flowella]: 'Flowella',
  [CtxCities.FlowerMound]: 'Flower Mound',
  [CtxCities.Floydada]: 'Floydada',
  [CtxCities.Follett]: 'Follett',
  [CtxCities.ForestHill]: 'Forest Hill',
  [CtxCities.Forney]: 'Forney',
  [CtxCities.Forsan]: 'Forsan',
  [CtxCities.FortBliss]: 'Fort Bliss',
  [CtxCities.FortClarkSprings]: 'Fort Clark Springs',
  [CtxCities.FortDavis]: 'Fort Davis',
  [CtxCities.FortHancock]: 'Fort Hancock',
  [CtxCities.FortHood]: 'Fort Hood',
  [CtxCities.FortStockton]: 'Fort Stockton',
  [CtxCities.FortWorth]: 'Fort Worth',
  [CtxCities.FourCorners]: 'Four Corners',
  [CtxCities.FourPoints]: 'Four Points',
  [CtxCities.Fowlerton]: 'Fowlerton',
  [CtxCities.Francitas]: 'Francitas',
  [CtxCities.Franklin]: 'Franklin',
  [CtxCities.Frankston]: 'Frankston',
  [CtxCities.Fredericksburg]: 'Fredericksburg',
  [CtxCities.Freeport]: 'Freeport',
  [CtxCities.Freer]: 'Freer',
  [CtxCities.Fresno]: 'Fresno',
  [CtxCities.Friendswood]: 'Friendswood',
  [CtxCities.Friona]: 'Friona',
  [CtxCities.Frisco]: 'Frisco',
  [CtxCities.Fritch]: 'Fritch',
  [CtxCities.Fronton]: 'Fronton',
  [CtxCities.FrontonRanchettes]: 'Fronton Ranchettes',
  [CtxCities.Frost]: 'Frost',
  [CtxCities.Fruitvale]: 'Fruitvale',
  [CtxCities.Fulshear]: 'Fulshear',
  [CtxCities.Fulton]: 'Fulton',
  [CtxCities.Gail]: 'Gail',
  [CtxCities.Gainesville]: 'Gainesville',
  [CtxCities.GalenaPark]: 'Galena Park',
  [CtxCities.Gallatin]: 'Gallatin',
  [CtxCities.Galveston]: 'Galveston',
  [CtxCities.Ganado]: 'Ganado',
  [CtxCities.Garceno]: 'Garceno',
  [CtxCities.Garciasville]: 'Garciasville',
  [CtxCities.GardenCity]: 'Garden City',
  [CtxCities.GardenRidge]: 'Garden Ridge',
  [CtxCities.Gardendale]: 'Gardendale',
  [CtxCities.Garfield]: 'Garfield',
  [CtxCities.Garland]: 'Garland',
  [CtxCities.Garrett]: 'Garrett',
  [CtxCities.Garrison]: 'Garrison',
  [CtxCities.Garwood]: 'Garwood',
  [CtxCities.GaryCity]: 'Gary City',
  [CtxCities.GarzaSalinasII]: 'Garza-Salinas II',
  [CtxCities.Gatesville]: 'Gatesville',
  [CtxCities.Gause]: 'Gause',
  [CtxCities.GeorgeWest]: 'George West',
  [CtxCities.Georgetown]: 'Georgetown',
  [CtxCities.Geronimo]: 'Geronimo',
  [CtxCities.Gholson]: 'Gholson',
  [CtxCities.Giddings]: 'Giddings',
  [CtxCities.Gilchrist]: 'Gilchrist',
  [CtxCities.Gillett]: 'Gillett',
  [CtxCities.Gilmer]: 'Gilmer',
  [CtxCities.Girard]: 'Girard',
  [CtxCities.Gladewater]: 'Gladewater',
  [CtxCities.GlenRose]: 'Glen Rose',
  [CtxCities.GlennHeights]: 'Glenn Heights',
  [CtxCities.Glidden]: 'Glidden',
  [CtxCities.Godley]: 'Godley',
  [CtxCities.Goldsmith]: 'Goldsmith',
  [CtxCities.Goldthwaite]: 'Goldthwaite',
  [CtxCities.Goliad]: 'Goliad',
  [CtxCities.Golinda]: 'Golinda',
  [CtxCities.Gonzales]: 'Gonzales',
  [CtxCities.Goodlow]: 'Goodlow',
  [CtxCities.Goodrich]: 'Goodrich',
  [CtxCities.Gordon]: 'Gordon',
  [CtxCities.Goree]: 'Goree',
  [CtxCities.Gorman]: 'Gorman',
  [CtxCities.Graford]: 'Graford',
  [CtxCities.Graham]: 'Graham',
  [CtxCities.Granbury]: 'Granbury',
  [CtxCities.GrandAcres]: 'Grand Acres',
  [CtxCities.GrandPrairie]: 'Grand Prairie',
  [CtxCities.GrandSaline]: 'Grand Saline',
  [CtxCities.Grandfalls]: 'Grandfalls',
  [CtxCities.Grandview]: 'Grandview',
  [CtxCities.Granger]: 'Granger',
  [CtxCities.GraniteShoals]: 'Granite Shoals',
  [CtxCities.Granjeno]: 'Granjeno',
  [CtxCities.GrapeCreek]: 'Grape Creek',
  [CtxCities.Grapeland]: 'Grapeland',
  [CtxCities.Grapevine]: 'Grapevine',
  [CtxCities.GraysPrairie]: 'Grays Prairie',
  [CtxCities.Greatwood]: 'Greatwood',
  [CtxCities.GreenValleyFarms]: 'Green Valley Farms',
  [CtxCities.Greenville]: 'Greenville',
  [CtxCities.Gregory]: 'Gregory',
  [CtxCities.GreyForest]: 'Grey Forest',
  [CtxCities.Groesbeck]: 'Groesbeck',
  [CtxCities.Groom]: 'Groom',
  [CtxCities.Groves]: 'Groves',
  [CtxCities.Groveton]: 'Groveton',
  [CtxCities.Gruver]: 'Gruver',
  [CtxCities.GuadalupeGuerra]: 'Guadalupe Guerra',
  [CtxCities.Guerra]: 'Guerra',
  [CtxCities.GunBarrelCity]: 'Gun Barrel City',
  [CtxCities.Gunter]: 'Gunter',
  [CtxCities.Gustine]: 'Gustine',
  [CtxCities.Guthrie]: 'Guthrie',
  [CtxCities.Gutierrez]: 'Gutierrez',
  [CtxCities.HCuellareStates]: 'H. Cuellar eStates',
  [CtxCities.Hackberry]: 'Hackberry',
  [CtxCities.HaleCenter]: 'Hale Center',
  [CtxCities.Hallettsville]: 'Hallettsville',
  [CtxCities.Hallsburg]: 'Hallsburg',
  [CtxCities.Hallsville]: 'Hallsville',
  [CtxCities.HaltomCity]: 'Haltom City',
  [CtxCities.Hamilton]: 'Hamilton',
  [CtxCities.Hamlin]: 'Hamlin',
  [CtxCities.Happy]: 'Happy',
  [CtxCities.Hardin]: 'Hardin',
  [CtxCities.Hargill]: 'Hargill',
  [CtxCities.HarkerHeights]: 'Harker Heights',
  [CtxCities.Harlingen]: 'Harlingen',
  [CtxCities.Harper]: 'Harper',
  [CtxCities.Hart]: 'Hart',
  [CtxCities.Hartley]: 'Hartley',
  [CtxCities.Harwood]: 'Harwood',
  [CtxCities.Haskell]: 'Haskell',
  [CtxCities.Haslet]: 'Haslet',
  [CtxCities.Havana]: 'Havana',
  [CtxCities.HawkCove]: 'Hawk Cove',
  [CtxCities.Hawkins]: 'Hawkins',
  [CtxCities.Hawley]: 'Hawley',
  [CtxCities.Hays]: 'Hays',
  [CtxCities.Hearne]: 'Hearne',
  [CtxCities.Heath]: 'Heath',
  [CtxCities.Hebbronville]: 'Hebbronville',
  [CtxCities.Hebron]: 'Hebron',
  [CtxCities.Hedley]: 'Hedley',
  [CtxCities.HedwigVillage]: 'Hedwig Village',
  [CtxCities.Heidelberg]: 'Heidelberg',
  [CtxCities.Heidenheimer]: 'Heidenheimer',
  [CtxCities.Helotes]: 'Helotes',
  [CtxCities.Hemphill]: 'Hemphill',
  [CtxCities.Hempstead]: 'Hempstead',
  [CtxCities.Henderson]: 'Henderson',
  [CtxCities.Henly]: 'Henly',
  [CtxCities.Henrietta]: 'Henrietta',
  [CtxCities.Hereford]: 'Hereford',
  [CtxCities.Hermleigh]: 'Hermleigh',
  [CtxCities.Hewitt]: 'Hewitt',
  [CtxCities.HickoryCreek]: 'Hickory Creek',
  [CtxCities.Hico]: 'Hico',
  [CtxCities.Hidalgo]: 'Hidalgo',
  [CtxCities.Hideaway]: 'Hideaway',
  [CtxCities.Higgins]: 'Higgins',
  [CtxCities.HighlandHaven]: 'Highland Haven',
  [CtxCities.HighlandPark]: 'Highland Park',
  [CtxCities.HighlandVillage]: 'Highland Village',
  [CtxCities.Highlands]: 'Highlands',
  [CtxCities.HillCountryVillage]: 'Hill Country Village',
  [CtxCities.Hillcrest]: 'Hillcrest',
  [CtxCities.Hillsboro]: 'Hillsboro',
  [CtxCities.HillsideAcres]: 'Hillside Acres',
  [CtxCities.Hilltop]: 'Hilltop',
  [CtxCities.HilltopLakes]: 'Hilltop Lakes',
  [CtxCities.HilshireVillage]: 'Hilshire Village',
  [CtxCities.Hitchcock]: 'Hitchcock',
  [CtxCities.Hobson]: 'Hobson',
  [CtxCities.HolidayBeach]: 'Holiday Beach',
  [CtxCities.HolidayLakes]: 'Holiday Lakes',
  [CtxCities.Holland]: 'Holland',
  [CtxCities.Holliday]: 'Holliday',
  [CtxCities.HollyLakeRanch]: 'Holly Lake Ranch',
  [CtxCities.HollywoodPark]: 'Hollywood Park',
  [CtxCities.HomesteadMeadowsNorth]: 'Homestead Meadows North',
  [CtxCities.HomesteadMeadowsSouth]: 'Homestead Meadows South',
  [CtxCities.Hondo]: 'Hondo',
  [CtxCities.HoneyGrove]: 'Honey Grove',
  [CtxCities.Hooks]: 'Hooks',
  [CtxCities.HorizonCity]: 'Horizon City',
  [CtxCities.HornsbyBend]: 'Hornsby Bend',
  [CtxCities.HorseshoeBay]: 'Horseshoe Bay',
  [CtxCities.HorseshoeBend]: 'Horseshoe Bend',
  [CtxCities.Houston]: 'Houston',
  [CtxCities.Howardwick]: 'Howardwick',
  [CtxCities.Howe]: 'Howe',
  [CtxCities.Hubbard]: 'Hubbard',
  [CtxCities.Hudson]: 'Hudson',
  [CtxCities.HudsonBend]: 'Hudson Bend',
  [CtxCities.HudsonOaks]: 'Hudson Oaks',
  [CtxCities.HughesSprings]: 'Hughes Springs',
  [CtxCities.Hull]: 'Hull',
  [CtxCities.Humble]: 'Humble',
  [CtxCities.Hungerford]: 'Hungerford',
  [CtxCities.Hunt]: 'Hunt',
  [CtxCities.HuntersCreekVillage]: 'Hunters Creek Village',
  [CtxCities.Huntington]: 'Huntington',
  [CtxCities.Huntsville]: 'Huntsville',
  [CtxCities.Hurst]: 'Hurst',
  [CtxCities.Hutchins]: 'Hutchins',
  [CtxCities.Hutto]: 'Hutto',
  [CtxCities.Huxley]: 'Huxley',
  [CtxCities.Hye]: 'Hye',
  [CtxCities.Iago]: 'Iago',
  [CtxCities.Idalou]: 'Idalou',
  [CtxCities.IglesiaAntigua]: 'Iglesia Antigua',
  [CtxCities.Impact]: 'Impact',
  [CtxCities.Imperial]: 'Imperial',
  [CtxCities.IndianGap]: 'Indian Gap',
  [CtxCities.IndianHills]: 'Indian Hills',
  [CtxCities.IndianLake]: 'Indian Lake',
  [CtxCities.IndianSprings]: 'Indian Springs',
  [CtxCities.Indio]: 'Indio',
  [CtxCities.Industry]: 'Industry',
  [CtxCities.Inez]: 'Inez',
  [CtxCities.Ingleside]: 'Ingleside',
  [CtxCities.InglesideontheBay]: 'Ingleside on the Bay',
  [CtxCities.Ingram]: 'Ingram',
  [CtxCities.Iola]: 'Iola',
  [CtxCities.IowaColony]: 'Iowa Colony',
  [CtxCities.IowaPark]: 'Iowa Park',
  [CtxCities.Iraan]: 'Iraan',
  [CtxCities.Iredell]: 'Iredell',
  [CtxCities.Irving]: 'Irving',
  [CtxCities.Italy]: 'Italy',
  [CtxCities.Itasca]: 'Itasca',
  [CtxCities.Ivanhoe]: 'Ivanhoe',
  [CtxCities.JacintoCity]: 'Jacinto City',
  [CtxCities.Jacksboro]: 'Jacksboro',
  [CtxCities.Jacksonville]: 'Jacksonville',
  [CtxCities.JamaicaBeach]: 'Jamaica Beach',
  [CtxCities.JardindeSanJulian]: 'Jardin de San Julian',
  [CtxCities.Jarrell]: 'Jarrell',
  [CtxCities.Jasper]: 'Jasper',
  [CtxCities.Jayton]: 'Jayton',
  [CtxCities.Jefferson]: 'Jefferson',
  [CtxCities.JerseyVillage]: 'Jersey Village',
  [CtxCities.Jewett]: 'Jewett',
  [CtxCities.JFVillarreal]: 'JF Villarreal',
  [CtxCities.Joaquin]: 'Joaquin',
  [CtxCities.JohnsonCity]: 'Johnson City',
  [CtxCities.Jolly]: 'Jolly',
  [CtxCities.JonesCreek]: 'Jones Creek',
  [CtxCities.Jonesboro]: 'Jonesboro',
  [CtxCities.Jonestown]: 'Jonestown',
  [CtxCities.Josephine]: 'Josephine',
  [CtxCities.Joshua]: 'Joshua',
  [CtxCities.Jourdanton]: 'Jourdanton',
  [CtxCities.Juarez]: 'Juarez',
  [CtxCities.Junction]: 'Junction',
  [CtxCities.Justin]: 'Justin',
  [CtxCities.KBarRanch]: 'K-Bar Ranch',
  [CtxCities.KarnesCity]: 'Karnes City',
  [CtxCities.Katy]: 'Katy',
  [CtxCities.Kaufman]: 'Kaufman',
  [CtxCities.Keene]: 'Keene',
  [CtxCities.Keller]: 'Keller',
  [CtxCities.Kemah]: 'Kemah',
  [CtxCities.Kemp]: 'Kemp',
  [CtxCities.Kempner]: 'Kempner',
  [CtxCities.Kendalia]: 'Kendalia',
  [CtxCities.Kendleton]: 'Kendleton',
  [CtxCities.Kenedy]: 'Kenedy',
  [CtxCities.Kenefick]: 'Kenefick',
  [CtxCities.Kennard]: 'Kennard',
  [CtxCities.Kennedale]: 'Kennedale',
  [CtxCities.Kerens]: 'Kerens',
  [CtxCities.Kermit]: 'Kermit',
  [CtxCities.Kerrville]: 'Kerrville',
  [CtxCities.Kilgore]: 'Kilgore',
  [CtxCities.Killeen]: 'Killeen',
  [CtxCities.Kingsbury]: 'Kingsbury',
  [CtxCities.Kingsland]: 'Kingsland',
  [CtxCities.Kingsville]: 'Kingsville',
  [CtxCities.Kirby]: 'Kirby',
  [CtxCities.Kirbyville]: 'Kirbyville',
  [CtxCities.Kirvin]: 'Kirvin',
  [CtxCities.Knippa]: 'Knippa',
  [CtxCities.Knollwood]: 'Knollwood',
  [CtxCities.KnoxCity]: 'Knox City',
  [CtxCities.Kopperl]: 'Kopperl',
  [CtxCities.Kosse]: 'Kosse',
  [CtxCities.Kountze]: 'Kountze',
  [CtxCities.Kress]: 'Kress',
  [CtxCities.Krugerville]: 'Krugerville',
  [CtxCities.Krum]: 'Krum',
  [CtxCities.Kurten]: 'Kurten',
  [CtxCities.Kyle]: 'Kyle',
  [CtxCities.LaBlanca]: 'La Blanca',
  [CtxCities.LaCarla]: 'La Carla',
  [CtxCities.LaCasita]: 'La Casita',
  [CtxCities.LaChuparosa]: 'La Chuparosa',
  [CtxCities.LaComa]: 'La Coma',
  [CtxCities.LaEscondida]: 'La Escondida',
  [CtxCities.LaEsperanza]: 'La Esperanza',
  [CtxCities.LaFeria]: 'La Feria',
  [CtxCities.LaFeriaNorth]: 'La Feria North',
  [CtxCities.LaGrange]: 'La Grange',
  [CtxCities.LaGrulla]: 'La Grulla',
  [CtxCities.LaHoma]: 'La Homa',
  [CtxCities.LaJoya]: 'La Joya',
  [CtxCities.LaLomadeFalcon]: 'La Loma de Falcon',
  [CtxCities.LaMarque]: 'La Marque',
  [CtxCities.LaMinita]: 'La Minita',
  [CtxCities.LaPaloma]: 'La Paloma',
  [CtxCities.LaPalomaAddition]: 'La Paloma Addition',
  [CtxCities.LaPalomaRanchettes]: 'La Paloma Ranchettes',
  [CtxCities.LaPalomaLostCreek]: 'La Paloma-Lost Creek',
  [CtxCities.LaPorte]: 'La Porte',
  [CtxCities.LaPresa]: 'La Presa',
  [CtxCities.LaPryor]: 'La Pryor',
  [CtxCities.LaPuerta]: 'La Puerta',
  [CtxCities.LaRosita]: 'La Rosita',
  [CtxCities.LaTinaRanch]: 'La Tina Ranch',
  [CtxCities.LaVernia]: 'La Vernia',
  [CtxCities.LaVictoria]: 'La Victoria',
  [CtxCities.LaVilla]: 'La Villa',
  [CtxCities.LaWard]: 'La Ward',
  [CtxCities.LacklandAFB]: 'Lackland AFB',
  [CtxCities.LaCoste]: 'LaCoste',
  [CtxCities.LacyLakeview]: 'Lacy-Lakeview',
  [CtxCities.Ladonia]: 'Ladonia',
  [CtxCities.Lago]: 'Lago',
  [CtxCities.LagoVista]: 'Lago Vista',
  [CtxCities.LagunaHeights]: 'Laguna Heights',
  [CtxCities.LagunaPark]: 'Laguna Park',
  [CtxCities.LagunaSeca]: 'Laguna Seca',
  [CtxCities.LagunaVista]: 'Laguna Vista',
  [CtxCities.LakeBridgeport]: 'Lake Bridgeport',
  [CtxCities.LakeBrownwood]: 'Lake Brownwood',
  [CtxCities.LakeBryan]: 'Lake Bryan',
  [CtxCities.LakeCherokee]: 'Lake Cherokee',
  [CtxCities.LakeCity]: 'Lake City',
  [CtxCities.LakeColoradoCity]: 'Lake Colorado City',
  [CtxCities.LakeDallas]: 'Lake Dallas',
  [CtxCities.LakeDunlap]: 'Lake Dunlap',
  [CtxCities.LakeJackson]: 'Lake Jackson',
  [CtxCities.LakeKiowa]: 'Lake Kiowa',
  [CtxCities.LakeMedinaShores]: 'Lake Medina Shores',
  [CtxCities.LakeMereditheStates]: 'Lake Meredith eStates',
  [CtxCities.LakeTanglewood]: 'Lake Tanglewood',
  [CtxCities.LakeView]: 'Lake View',
  [CtxCities.LakeWorth]: 'Lake Worth',
  [CtxCities.Lakehills]: 'Lakehills',
  [CtxCities.Lakeport]: 'Lakeport',
  [CtxCities.LakeshoreGardensHiddenAcres]: 'Lakeshore Gardens-Hidden Acres',
  [CtxCities.Lakeside]: 'Lakeside',
  [CtxCities.LakesideCity]: 'Lakeside City',
  [CtxCities.Lakeway]: 'Lakeway',
  [CtxCities.LakewoodVillage]: 'Lakewood Village',
  [CtxCities.Lamar]: 'Lamar',
  [CtxCities.Lamesa]: 'Lamesa',
  [CtxCities.Lampasas]: 'Lampasas',
  [CtxCities.Lancaster]: 'Lancaster',
  [CtxCities.Lanham]: 'Lanham',
  [CtxCities.Lantana]: 'Lantana',
  [CtxCities.Laredo]: 'Laredo',
  [CtxCities.LaredoRanchettes]: 'Laredo Ranchettes',
  [CtxCities.LaredoRanchettesWest]: 'Laredo Ranchettes West',
  [CtxCities.LasHaciendas]: 'Las Haciendas',
  [CtxCities.LasLomas]: 'Las Lomas',
  [CtxCities.LasLomitas]: 'Las Lomitas',
  [CtxCities.LasPalmas]: 'Las Palmas',
  [CtxCities.LasPalmasII]: 'Las Palmas II',
  [CtxCities.LasPilas]: 'Las Pilas',
  [CtxCities.LasQuintasFronterizas]: 'Las Quintas Fronterizas',
  [CtxCities.LaSalle]: 'LaSalle',
  [CtxCities.Lasana]: 'Lasana',
  [CtxCities.Lasara]: 'Lasara',
  [CtxCities.Latexo]: 'Latexo',
  [CtxCities.LaughlinAFB]: 'Laughlin AFB',
  [CtxCities.Laureles]: 'Laureles',
  [CtxCities.Lavon]: 'Lavon',
  [CtxCities.Lawn]: 'Lawn',
  [CtxCities.LeagueCity]: 'League City',
  [CtxCities.Leakey]: 'Leakey',
  [CtxCities.Leander]: 'Leander',
  [CtxCities.Leary]: 'Leary',
  [CtxCities.Ledbetter]: 'Ledbetter',
  [CtxCities.Leesville]: 'Leesville',
  [CtxCities.Lefors]: 'Lefors',
  [CtxCities.Leming]: 'Leming',
  [CtxCities.LeonValley]: 'Leon Valley',
  [CtxCities.Leona]: 'Leona',
  [CtxCities.Leonard]: 'Leonard',
  [CtxCities.Leroy]: 'Leroy',
  [CtxCities.Levelland]: 'Levelland',
  [CtxCities.Lewisville]: 'Lewisville',
  [CtxCities.Lexington]: 'Lexington',
  [CtxCities.Liberty]: 'Liberty',
  [CtxCities.LibertyCity]: 'Liberty City',
  [CtxCities.LibertyHill]: 'Liberty Hill',
  [CtxCities.LincolnPark]: 'Lincoln Park',
  [CtxCities.Lindale]: 'Lindale',
  [CtxCities.Linden]: 'Linden',
  [CtxCities.Lindsay]: 'Lindsay',
  [CtxCities.Linn]: 'Linn',
  [CtxCities.Lipan]: 'Lipan',
  [CtxCities.Lipscomb]: 'Lipscomb',
  [CtxCities.LittleElm]: 'Little Elm',
  [CtxCities.LittleRiverAcademy]: 'Little River-Academy',
  [CtxCities.Littlefield]: 'Littlefield',
  [CtxCities.LiveOak]: 'Live Oak',
  [CtxCities.Liverpool]: 'Liverpool',
  [CtxCities.Livingston]: 'Livingston',
  [CtxCities.Llano]: 'Llano',
  [CtxCities.LlanoGrande]: 'Llano Grande',
  [CtxCities.Lockhart]: 'Lockhart',
  [CtxCities.Lockney]: 'Lockney',
  [CtxCities.LogCabin]: 'Log Cabin',
  [CtxCities.Lolita]: 'Lolita',
  [CtxCities.LomaGrande]: 'Loma Grande',
  [CtxCities.LomaLinda]: 'Loma Linda',
  [CtxCities.LomaLindaEast]: 'Loma Linda East',
  [CtxCities.LomaLindaWest]: 'Loma Linda West',
  [CtxCities.LomaVista]: 'Loma Vista',
  [CtxCities.Lometa]: 'Lometa',
  [CtxCities.LoneOak]: 'Lone Oak',
  [CtxCities.LoneStar]: 'Lone Star',
  [CtxCities.Longoria]: 'Longoria',
  [CtxCities.Longview]: 'Longview',
  [CtxCities.Loop]: 'Loop',
  [CtxCities.Lopeño]: 'Lopeño',
  [CtxCities.Lopezville]: 'Lopezville',
  [CtxCities.Loraine]: 'Loraine',
  [CtxCities.Lorena]: 'Lorena',
  [CtxCities.Lorenzo]: 'Lorenzo',
  [CtxCities.LosAltos]: 'Los Altos',
  [CtxCities.LosAlvarez]: 'Los Alvarez',
  [CtxCities.LosAngeles]: 'Los Angeles',
  [CtxCities.LosArcos]: 'Los Arcos',
  [CtxCities.LosArrieros]: 'Los Arrieros',
  [CtxCities.LosBarreras]: 'Los Barreras',
  [CtxCities.LosCentenarios]: 'Los Centenarios',
  [CtxCities.LosCorralitos]: 'Los Corralitos',
  [CtxCities.LosEbanos]: 'Los Ebanos',
  [CtxCities.LosFresnos]: 'Los Fresnos',
  [CtxCities.LosHuisaches]: 'Los Huisaches',
  [CtxCities.LosIndios]: 'Los Indios',
  [CtxCities.LosMinerales]: 'Los Minerales',
  [CtxCities.LosNopalitos]: 'Los Nopalitos',
  [CtxCities.LosVeteranosI]: 'Los Veteranos I',
  [CtxCities.LosVeteranosII]: 'Los Veteranos II',
  [CtxCities.LosYbanez]: 'Los Ybanez',
  [CtxCities.LostCreek]: 'Lost Creek',
  [CtxCities.Lott]: 'Lott',
  [CtxCities.Louise]: 'Louise',
  [CtxCities.Lovelady]: 'Lovelady',
  [CtxCities.LowryCrossing]: 'Lowry Crossing',
  [CtxCities.Lozano]: 'Lozano',
  [CtxCities.Lubbock]: 'Lubbock',
  [CtxCities.Lucas]: 'Lucas',
  [CtxCities.Lueders]: 'Lueders',
  [CtxCities.Lufkin]: 'Lufkin',
  [CtxCities.Luling]: 'Luling',
  [CtxCities.Lumberton]: 'Lumberton',
  [CtxCities.Lyford]: 'Lyford',
  [CtxCities.Lytle]: 'Lytle',
  [CtxCities.LyttonSprings]: 'Lytton Springs',
  [CtxCities.Mabank]: 'Mabank',
  [CtxCities.Macdona]: 'Macdona',
  [CtxCities.Madisonville]: 'Madisonville',
  [CtxCities.Magnolia]: 'Magnolia',
  [CtxCities.Malakoff]: 'Malakoff',
  [CtxCities.Malone]: 'Malone',
  [CtxCities.Manchaca]: 'Manchaca',
  [CtxCities.Manor]: 'Manor',
  [CtxCities.Mansfield]: 'Mansfield',
  [CtxCities.ManuelGarcia]: 'Manuel Garcia',
  [CtxCities.ManuelGarciaII]: 'Manuel Garcia II',
  [CtxCities.Manvel]: 'Manvel',
  [CtxCities.Marathon]: 'Marathon',
  [CtxCities.MarbleFalls]: 'Marble Falls',
  [CtxCities.Marfa]: 'Marfa',
  [CtxCities.Marietta]: 'Marietta',
  [CtxCities.Marion]: 'Marion',
  [CtxCities.Markham]: 'Markham',
  [CtxCities.Marlin]: 'Marlin',
  [CtxCities.Marquez]: 'Marquez',
  [CtxCities.Marshall]: 'Marshall',
  [CtxCities.Mart]: 'Mart',
  [CtxCities.Martindale]: 'Martindale',
  [CtxCities.Martinez]: 'Martinez',
  [CtxCities.Mason]: 'Mason',
  [CtxCities.Matador]: 'Matador',
  [CtxCities.Matagorda]: 'Matagorda',
  [CtxCities.Mathis]: 'Mathis',
  [CtxCities.Maud]: 'Maud',
  [CtxCities.Mauriceville]: 'Mauriceville',
  [CtxCities.Maxwell]: 'Maxwell',
  [CtxCities.Maypearl]: 'Maypearl',
  [CtxCities.Maysfield]: 'Maysfield',
  [CtxCities.McAllen]: 'McAllen',
  [CtxCities.McCamey]: 'McCamey',
  [CtxCities.McDade]: 'McDade',
  [CtxCities.McGregor]: 'McGregor',
  [CtxCities.McKinney]: 'McKinney',
  [CtxCities.McKinneyAcres]: 'McKinney Acres',
  [CtxCities.McLean]: 'McLean',
  [CtxCities.McLendonChisholm]: 'McLendon-Chisholm',
  [CtxCities.McMahan]: 'McMahan',
  [CtxCities.McNeil]: 'McNeil',
  [CtxCities.McQueeney]: 'McQueeney',
  [CtxCities.Meadow]: 'Meadow',
  [CtxCities.Meadowlakes]: 'Meadowlakes',
  [CtxCities.MeadowsPlace]: 'Meadows Place',
  [CtxCities.Medina]: 'Medina ',
  [CtxCities.Megargel]: 'Megargel',
  [CtxCities.Melissa]: 'Melissa',
  [CtxCities.Melvin]: 'Melvin',
  [CtxCities.Memphis]: 'Memphis',
  [CtxCities.Menard]: 'Menard',
  [CtxCities.Mentone]: 'Mentone',
  [CtxCities.Mercedes]: 'Mercedes',
  [CtxCities.Meridian]: 'Meridian',
  [CtxCities.Merkel]: 'Merkel',
  [CtxCities.Mertens]: 'Mertens',
  [CtxCities.Mertzon]: 'Mertzon',
  [CtxCities.Mesquite]: 'Mesquite',
  [CtxCities.Mexia]: 'Mexia',
  [CtxCities.Meyersville]: 'Meyersville',
  [CtxCities.MiRanchitoEstate]: 'Mi Ranchito Estate',
  [CtxCities.Miami]: 'Miami',
  [CtxCities.Mico]: 'Mico',
  [CtxCities.Midfield]: 'Midfield',
  [CtxCities.Midland]: 'Midland',
  [CtxCities.Midlothian]: 'Midlothian',
  [CtxCities.Midway]: 'Midway',
  [CtxCities.MidwayNorth]: 'Midway North',
  [CtxCities.MidwaySouth]: 'Midway South',
  [CtxCities.MiguelBarrera]: 'Miguel Barrera',
  [CtxCities.Mikes]: 'Mikes',
  [CtxCities.MilaDoce]: 'Mila Doce',
  [CtxCities.Milam]: 'Milam',
  [CtxCities.Milano]: 'Milano',
  [CtxCities.Mildred]: 'Mildred',
  [CtxCities.Miles]: 'Miles',
  [CtxCities.Milford]: 'Milford',
  [CtxCities.MillersCove]: 'Miller"s Cove',
  [CtxCities.Millican]: 'Millican',
  [CtxCities.Millsap]: 'Millsap',
  [CtxCities.Mineola]: 'Mineola',
  [CtxCities.MineralWells]: 'Mineral Wells',
  [CtxCities.Mingus]: 'Mingus',
  [CtxCities.MirandoCity]: 'Mirando City',
  [CtxCities.Mission]: 'Mission',
  [CtxCities.MissionBend]: 'Mission Bend',
  [CtxCities.MissouriCity]: 'Missouri City',
  [CtxCities.Mobeetie]: 'Mobeetie',
  [CtxCities.MobileCity]: 'Mobile City',
  [CtxCities.Moffat]: 'Moffat',
  [CtxCities.Monahans]: 'Monahans',
  [CtxCities.MontBelvieu]: 'Mont Belvieu',
  [CtxCities.Montague]: 'Montague',
  [CtxCities.Montalba]: 'Montalba',
  [CtxCities.MonteAlto]: 'Monte Alto',
  [CtxCities.Montgomery]: 'Montgomery',
  [CtxCities.Moody]: 'Moody',
  [CtxCities.Moore]: 'Moore',
  [CtxCities.MooreStation]: 'Moore Station',
  [CtxCities.Moraida]: 'Moraida',
  [CtxCities.MoralesSanchez]: 'Morales-Sanchez',
  [CtxCities.Moran]: 'Moran',
  [CtxCities.Morgan]: 'Morgan',
  [CtxCities.MorganFarm]: 'Morgan Farm',
  [CtxCities.MorgansPoint]: 'Morgans Point',
  [CtxCities.MorgansPointResort]: 'Morgans Point Resort',
  [CtxCities.MorningGlory]: 'Morning Glory',
  [CtxCities.Morse]: 'Morse',
  [CtxCities.Morton]: 'Morton',
  [CtxCities.Moulton]: 'Moulton',
  [CtxCities.Mound]: 'Mound',
  [CtxCities.MountCalm]: 'Mount Calm',
  [CtxCities.MountEnterprise]: 'Mount Enterprise',
  [CtxCities.MountPleasant]: 'Mount Pleasant',
  [CtxCities.MountVernon]: 'Mount Vernon',
  [CtxCities.MountainCity]: 'Mountain City',
  [CtxCities.MountainHome]: 'Mountain Home',
  [CtxCities.Muenster]: 'Muenster',
  [CtxCities.Muleshoe]: 'Muleshoe',
  [CtxCities.Mullin]: 'Mullin',
  [CtxCities.Munday]: 'Munday',
  [CtxCities.Muniz]: 'Muniz',
  [CtxCities.Murchison]: 'Murchison',
  [CtxCities.Murillo]: 'Murillo',
  [CtxCities.Murphy]: 'Murphy',
  [CtxCities.Mustang]: 'Mustang',
  [CtxCities.MustangRidge]: 'Mustang Ridge',
  [CtxCities.MyrtleSprings]: 'Myrtle Springs',
  [CtxCities.Nacogdoches]: 'Nacogdoches',
  [CtxCities.Nada]: 'Nada',
  [CtxCities.Naples]: 'Naples',
  [CtxCities.NarcisoPena]: 'Narciso Pena',
  [CtxCities.Naruna]: 'Naruna',
  [CtxCities.Nash]: 'Nash',
  [CtxCities.NassauBay]: 'Nassau Bay',
  [CtxCities.Natalia]: 'Natalia',
  [CtxCities.Navarro]: 'Navarro',
  [CtxCities.Navasota]: 'Navasota',
  [CtxCities.Nazareth]: 'Nazareth',
  [CtxCities.Nederland]: 'Nederland',
  [CtxCities.Needville]: 'Needville',
  [CtxCities.Nesbitt]: 'Nesbitt',
  [CtxCities.Netos]: 'Netos',
  [CtxCities.Nevada]: 'Nevada',
  [CtxCities.NewBerlin]: 'New Berlin',
  [CtxCities.NewBoston]: 'New Boston',
  [CtxCities.NewBraunfels]: 'New Braunfels',
  [CtxCities.NewChapelHill]: 'New Chapel Hill',
  [CtxCities.NewDeal]: 'New Deal',
  [CtxCities.NewFairview]: 'New Fairview',
  [CtxCities.NewFalcon]: 'New Falcon',
  [CtxCities.NewHome]: 'New Home',
  [CtxCities.NewHope]: 'New Hope',
  [CtxCities.NewLondon]: 'New London',
  [CtxCities.NewSummerfield]: 'New Summerfield',
  [CtxCities.NewTerritory]: 'New Territory',
  [CtxCities.NewWaverly]: 'New Waverly',
  [CtxCities.Newark]: 'Newark',
  [CtxCities.Newcastle]: 'Newcastle',
  [CtxCities.Newton]: 'Newton',
  [CtxCities.Neylandville]: 'Neylandville',
  [CtxCities.Niederwald]: 'Niederwald',
  [CtxCities.Nina]: 'Nina',
  [CtxCities.Nixon]: 'Nixon',
  [CtxCities.Nocona]: 'Nocona',
  [CtxCities.NoconaHills]: 'Nocona Hills',
  [CtxCities.Nolanville]: 'Nolanville',
  [CtxCities.Nome]: 'Nome',
  [CtxCities.Noonday]: 'Noonday',
  [CtxCities.Nordheim]: 'Nordheim',
  [CtxCities.Normangee]: 'Normangee',
  [CtxCities.Normanna]: 'Normanna',
  [CtxCities.NorthAlamo]: 'North Alamo',
  [CtxCities.NorthCleveland]: 'North Cleveland',
  [CtxCities.NorthEscobares]: 'North Escobares',
  [CtxCities.NorthPearsall]: 'North Pearsall',
  [CtxCities.NorthRichlandHills]: 'North Richland Hills',
  [CtxCities.NorthSanPedro]: 'North San Pedro',
  [CtxCities.Northlake]: 'Northlake',
  [CtxCities.Northridge]: 'Northridge',
  [CtxCities.Novice]: 'Novice',
  [CtxCities.Nursery]: 'Nursery',
  [CtxCities.OBrien]: 'O"Brien',
  [CtxCities.ODonnell]: 'O"Donnell',
  [CtxCities.OakGrove]: 'Oak Grove',
  [CtxCities.OakIsland]: 'Oak Island',
  [CtxCities.OakLeaf]: 'Oak Leaf',
  [CtxCities.OakPoint]: 'Oak Point',
  [CtxCities.OakRidge]: 'Oak Ridge',
  [CtxCities.OakRidgeNorth]: 'Oak Ridge North',
  [CtxCities.OakTrailShores]: 'Oak Trail Shores',
  [CtxCities.OakValley]: 'Oak Valley',
  [CtxCities.Oakalla]: 'Oakalla',
  [CtxCities.Oakhurst]: 'Oakhurst',
  [CtxCities.Oakwood]: 'Oakwood',
  [CtxCities.Odem]: 'Odem',
  [CtxCities.Odessa]: 'Odessa',
  [CtxCities.Oglesby]: 'Oglesby',
  [CtxCities.Oilton]: 'Oilton',
  [CtxCities.OldRiverWinfree]: 'Old River-Winfree',
  [CtxCities.Olivarez]: 'Olivarez',
  [CtxCities.OliviaLopezdeGutierrez]: 'Olivia Lopez de Gutierrez',
  [CtxCities.Olmito]: 'Olmito',
  [CtxCities.OlmitoandOlmito]: 'Olmito and Olmito',
  [CtxCities.OlmosPark]: 'Olmos Park',
  [CtxCities.Olney]: 'Olney',
  [CtxCities.Olton]: 'Olton',
  [CtxCities.Omaha]: 'Omaha',
  [CtxCities.Onalaska]: 'Onalaska',
  [CtxCities.OpdykeWest]: 'Opdyke West',
  [CtxCities.Orange]: 'Orange',
  [CtxCities.OrangeGrove]: 'Orange Grove',
  [CtxCities.Orason]: 'Orason',
  [CtxCities.Orchard]: 'Orchard',
  [CtxCities.OreCity]: 'Ore City',
  [CtxCities.Other]: 'Other',
  [CtxCities.Ottine]: 'Ottine',
  [CtxCities.Overton]: 'Overton',
  [CtxCities.Ovilla]: 'Ovilla',
  [CtxCities.OwlRanch]: 'Owl Ranch',
  [CtxCities.OysterCreek]: 'Oyster Creek',
  [CtxCities.Ozona]: 'Ozona',
  [CtxCities.PabloPena]: 'Pablo Pena',
  [CtxCities.Paducah]: 'Paducah',
  [CtxCities.Paige]: 'Paige',
  [CtxCities.PaintRock]: 'Paint Rock',
  [CtxCities.PaisanoPark]: 'Paisano Park',
  [CtxCities.Palacios]: 'Palacios',
  [CtxCities.Palestine]: 'Palestine',
  [CtxCities.Palisades]: 'Palisades',
  [CtxCities.PalmValley]: 'Palm Valley',
  [CtxCities.Palmer]: 'Palmer',
  [CtxCities.Palmhurst]: 'Palmhurst',
  [CtxCities.Palmview]: 'Palmview',
  [CtxCities.PalmviewSouth]: 'Palmview South',
  [CtxCities.PaloBlanco]: 'Palo Blanco',
  [CtxCities.PaloPinto]: 'Palo Pinto',
  [CtxCities.PalomaCreek]: 'Paloma Creek',
  [CtxCities.PalomaCreekSouth]: 'Paloma Creek South',
  [CtxCities.Pampa]: 'Pampa',
  [CtxCities.Pandora]: 'Pandora',
  [CtxCities.Panhandle]: 'Panhandle',
  [CtxCities.PanoramaVillage]: 'Panorama Village',
  [CtxCities.Pantego]: 'Pantego',
  [CtxCities.Paradise]: 'Paradise',
  [CtxCities.Paris]: 'Paris',
  [CtxCities.Parker]: 'Parker',
  [CtxCities.Pasadena]: 'Pasadena',
  [CtxCities.Pattison]: 'Pattison',
  [CtxCities.PattonVillage]: 'Patton Village',
  [CtxCities.Pawnee]: 'Pawnee',
  [CtxCities.PayneSprings]: 'Payne Springs',
  [CtxCities.Pearland]: 'Pearland',
  [CtxCities.Pearsall]: 'Pearsall',
  [CtxCities.PecanAcres]: 'Pecan Acres',
  [CtxCities.PecanGap]: 'Pecan Gap',
  [CtxCities.PecanGrove]: 'Pecan Grove',
  [CtxCities.PecanHill]: 'Pecan Hill',
  [CtxCities.PecanPlantation]: 'Pecan Plantation',
  [CtxCities.Pecos]: 'Pecos',
  [CtxCities.PelicanBay]: 'Pelican Bay',
  [CtxCities.Pena]: 'Pena',
  [CtxCities.Pendleton]: 'Pendleton',
  [CtxCities.Penelope]: 'Penelope',
  [CtxCities.Penitas]: 'Penitas',
  [CtxCities.Perezville]: 'Perezville',
  [CtxCities.Perrin]: 'Perrin',
  [CtxCities.Perry]: 'Perry',
  [CtxCities.Perryton]: 'Perryton',
  [CtxCities.Petersburg]: 'Petersburg',
  [CtxCities.Petrolia]: 'Petrolia',
  [CtxCities.Petronila]: 'Petronila',
  [CtxCities.Pettus]: 'Pettus',
  [CtxCities.Pflugerville]: 'Pflugerville',
  [CtxCities.Pharr]: 'Pharr',
  [CtxCities.Pidcoke]: 'Pidcoke',
  [CtxCities.PilotPoint]: 'Pilot Point',
  [CtxCities.PineForest]: 'Pine Forest',
  [CtxCities.PineHarbor]: 'Pine Harbor',
  [CtxCities.PineIsland]: 'Pine Island',
  [CtxCities.Pinehurst]: 'Pinehurst',
  [CtxCities.Pineland]: 'Pineland',
  [CtxCities.PinewoodeStates]: 'Pinewood eStates',
  [CtxCities.PineyPointVillage]: 'Piney Point Village',
  [CtxCities.PipeCreek]: 'Pipe Creek',
  [CtxCities.Pittsburg]: 'Pittsburg',
  [CtxCities.Placedo]: 'Placedo',
  [CtxCities.Plains]: 'Plains',
  [CtxCities.Plainview]: 'Plainview',
  [CtxCities.Plano]: 'Plano',
  [CtxCities.Pleak]: 'Pleak',
  [CtxCities.PleasantHill]: 'Pleasant Hill',
  [CtxCities.PleasantValley]: 'Pleasant Valley',
  [CtxCities.Pleasanton]: 'Pleasanton',
  [CtxCities.PlumGrove]: 'Plum Grove',
  [CtxCities.PointBlank]: 'Point Blank',
  [CtxCities.PointComfort]: 'Point Comfort',
  [CtxCities.PointVenture]: 'Point Venture',
  [CtxCities.Ponder]: 'Ponder',
  [CtxCities.PortAlto]: 'Port Alto',
  [CtxCities.PortAransas]: 'Port Aransas',
  [CtxCities.PortArthur]: 'Port Arthur',
  [CtxCities.PortIsabel]: 'Port Isabel',
  [CtxCities.PortLavaca]: 'Port Lavaca',
  [CtxCities.PortMansfield]: 'Port Mansfield',
  [CtxCities.PortNeches]: 'Port Neches',
  [CtxCities.PortOConnor]: 'Port O"Connor',
  [CtxCities.PorterHeights]: 'Porter Heights',
  [CtxCities.Portland]: 'Portland',
  [CtxCities.Post]: 'Post',
  [CtxCities.PostOakBendCity]: 'Post Oak Bend City',
  [CtxCities.Poteet]: 'Poteet',
  [CtxCities.Poth]: 'Poth',
  [CtxCities.Potosi]: 'Potosi',
  [CtxCities.Pottsboro]: 'Pottsboro',
  [CtxCities.Powderly]: 'Powderly',
  [CtxCities.Powell]: 'Powell',
  [CtxCities.Poynor]: 'Poynor',
  [CtxCities.PradoVerde]: 'Prado Verde',
  [CtxCities.PrairieHill]: 'Prairie Hill',
  [CtxCities.PrairieLea]: 'Prairie Lea',
  [CtxCities.Premont]: 'Premont',
  [CtxCities.Presidio]: 'Presidio',
  [CtxCities.Preston]: 'Preston',
  [CtxCities.Primera]: 'Primera',
  [CtxCities.Princeton]: 'Princeton',
  [CtxCities.Progreso]: 'Progreso',
  [CtxCities.ProgresoLakes]: 'Progreso Lakes',
  [CtxCities.Prosper]: 'Prosper',
  [CtxCities.ProvidenceVillage]: 'Providence Village',
  [CtxCities.PuebloEast]: 'Pueblo East',
  [CtxCities.PuebloNuevo]: 'Pueblo Nuevo',
  [CtxCities.Purmela]: 'Purmela',
  [CtxCities.Putnam]: 'Putnam',
  [CtxCities.Pyote]: 'Pyote',
  [CtxCities.Quail]: 'Quail',
  [CtxCities.QuailCreek]: 'Quail Creek',
  [CtxCities.Quanah]: 'Quanah',
  [CtxCities.QueenCity]: 'Queen City',
  [CtxCities.Quemado]: 'Quemado',
  [CtxCities.Quesada]: 'Quesada',
  [CtxCities.Quinlan]: 'Quinlan',
  [CtxCities.Quintana]: 'Quintana',
  [CtxCities.Quitaque]: 'Quitaque',
  [CtxCities.Quitman]: 'Quitman',
  [CtxCities.RadarBase]: 'Radar Base',
  [CtxCities.RafaelPena]: 'Rafael Pena',
  [CtxCities.Ralls]: 'Ralls',
  [CtxCities.Ramireno]: 'Ramireno',
  [CtxCities.RamirezPerez]: 'Ramirez-Perez',
  [CtxCities.Ramos]: 'Ramos',
  [CtxCities.RanchetteeStates]: 'Ranchette eStates',
  [CtxCities.RanchitosDelNorte]: 'Ranchitos Del Norte',
  [CtxCities.RanchitosEast]: 'Ranchitos East',
  [CtxCities.RanchitosLasLomas]: 'Ranchitos Las Lomas',
  [CtxCities.RanchoAlegre]: 'Rancho Alegre',
  [CtxCities.RanchoBanquete]: 'Rancho Banquete',
  [CtxCities.RanchoChico]: 'Rancho Chico',
  [CtxCities.RanchoViejo]: 'Rancho Viejo',
  [CtxCities.RanchosPenitasWest]: 'Ranchos Penitas West',
  [CtxCities.RandolphAFB]: 'Randolph AFB',
  [CtxCities.Ranger]: 'Ranger',
  [CtxCities.Rangerville]: 'Rangerville',
  [CtxCities.Rankin]: 'Rankin',
  [CtxCities.RansomCanyon]: 'Ransom Canyon',
  [CtxCities.Ratamosa]: 'Ratamosa',
  [CtxCities.Ravenna]: 'Ravenna',
  [CtxCities.Raymondville]: 'Raymondville',
  [CtxCities.Reagan]: 'Reagan',
  [CtxCities.Realitos]: 'Realitos',
  [CtxCities.RedLick]: 'Red Lick',
  [CtxCities.RedOak]: 'Red Oak',
  [CtxCities.RedRock]: 'Red Rock',
  [CtxCities.Redfield]: 'Redfield',
  [CtxCities.Redford]: 'Redford',
  [CtxCities.Redland]: 'Redland',
  [CtxCities.Redwater]: 'Redwater',
  [CtxCities.Redwood]: 'Redwood',
  [CtxCities.Reedville]: 'Reedville',
  [CtxCities.Refugio]: 'Refugio',
  [CtxCities.ReginoRamirez]: 'Regino Ramirez',
  [CtxCities.ReidHopeKing]: 'Reid Hope King',
  [CtxCities.Reklaw]: 'Reklaw',
  [CtxCities.Relampago]: 'Relampago',
  [CtxCities.Rendon]: 'Rendon',
  [CtxCities.Reno]: 'Reno',
  [CtxCities.Retreat]: 'Retreat',
  [CtxCities.Rhome]: 'Rhome',
  [CtxCities.Ricardo]: 'Ricardo',
  [CtxCities.Rice]: 'Rice',
  [CtxCities.Richardson]: 'Richardson',
  [CtxCities.Richland]: 'Richland',
  [CtxCities.RichlandHills]: 'Richland Hills',
  [CtxCities.RichlandSprings]: 'Richland Springs',
  [CtxCities.Richmond]: 'Richmond',
  [CtxCities.Richwood]: 'Richwood',
  [CtxCities.Riesel]: 'Riesel',
  [CtxCities.RioBravo]: 'Rio Bravo',
  [CtxCities.RioGrandeCity]: 'Rio Grande City',
  [CtxCities.RioHondo]: 'Rio Hondo',
  [CtxCities.RioVista]: 'Rio Vista',
  [CtxCities.RisingStar]: 'Rising Star',
  [CtxCities.RiverOaks]: 'River Oaks',
  [CtxCities.Rivereno]: 'Rivereno',
  [CtxCities.Riverside]: 'Riverside',
  [CtxCities.Riviera]: 'Riviera',
  [CtxCities.Roanoke]: 'Roanoke',
  [CtxCities.RoaringSprings]: 'Roaring Springs',
  [CtxCities.RobertLee]: 'Robert Lee',
  [CtxCities.Robinson]: 'Robinson',
  [CtxCities.Robstown]: 'Robstown',
  [CtxCities.Roby]: 'Roby',
  [CtxCities.Rochester]: 'Rochester',
  [CtxCities.Rockdale]: 'Rockdale',
  [CtxCities.Rockport]: 'Rockport',
  [CtxCities.Rocksprings]: 'Rocksprings',
  [CtxCities.Rockwall]: 'Rockwall',
  [CtxCities.RockyMound]: 'Rocky Mound',
  [CtxCities.Rogers]: 'Rogers',
  [CtxCities.Rollingwood]: 'Rollingwood',
  [CtxCities.Roma]: 'Roma',
  [CtxCities.RomaCreek]: 'Roma Creek',
  [CtxCities.RomanForest]: 'Roman Forest',
  [CtxCities.Ropesville]: 'Ropesville',
  [CtxCities.Rosanky]: 'Rosanky',
  [CtxCities.Roscoe]: 'Roscoe',
  [CtxCities.RoseCity]: 'Rose City',
  [CtxCities.RoseHillAcres]: 'Rose Hill Acres',
  [CtxCities.Rosebud]: 'Rosebud',
  [CtxCities.Rosenberg]: 'Rosenberg',
  [CtxCities.Rosharon]: 'Rosharon',
  [CtxCities.Rosita]: 'Rosita',
  [CtxCities.Ross]: 'Ross',
  [CtxCities.Rosser]: 'Rosser',
  [CtxCities.Rotan]: 'Rotan',
  [CtxCities.RoundMountain]: 'Round Mountain',
  [CtxCities.RoundRock]: 'Round Rock',
  [CtxCities.RoundTop]: 'Round Top',
  [CtxCities.Rowlett]: 'Rowlett',
  [CtxCities.Roxton]: 'Roxton',
  [CtxCities.RoyseCity]: 'Royse City',
  [CtxCities.Rule]: 'Rule',
  [CtxCities.RunawayBay]: 'Runaway Bay',
  [CtxCities.Runge]: 'Runge',
  [CtxCities.Rusk]: 'Rusk',
  [CtxCities.Sabinal]: 'Sabinal',
  [CtxCities.Sachse]: 'Sachse',
  [CtxCities.Sadler]: 'Sadler',
  [CtxCities.Saginaw]: 'Saginaw',
  [CtxCities.SaintHedwig]: 'Saint Hedwig',
  [CtxCities.Salado]: 'Salado',
  [CtxCities.Salineño]: 'Salineño',
  [CtxCities.SalineñoNorth]: 'Salineño North',
  [CtxCities.SamRayburn]: 'Sam Rayburn',
  [CtxCities.SammyMartinez]: 'Sammy Martinez',
  [CtxCities.Samnorwood]: 'Samnorwood',
  [CtxCities.SanAngelo]: 'San Angelo',
  [CtxCities.SanAntonio]: 'San Antonio',
  [CtxCities.SanAugustine]: 'San Augustine',
  [CtxCities.SanBenito]: 'San Benito',
  [CtxCities.SanCarlos]: 'San Carlos',
  [CtxCities.SanCarlosI]: 'San Carlos I',
  [CtxCities.SanCarlosII]: 'San Carlos II',
  [CtxCities.SanDiego]: 'San Diego',
  [CtxCities.SanElizario]: 'San Elizario',
  [CtxCities.SanFelipe]: 'San Felipe',
  [CtxCities.SanFernando]: 'San Fernando',
  [CtxCities.SanIsidro]: 'San Isidro',
  [CtxCities.SanJuan]: 'San Juan',
  [CtxCities.SanLeanna]: 'San Leanna',
  [CtxCities.SanLeon]: 'San Leon',
  [CtxCities.SanMarcos]: 'San Marcos',
  [CtxCities.SanPatricio]: 'San Patricio',
  [CtxCities.SanPedro]: 'San Pedro',
  [CtxCities.SanPerlita]: 'San Perlita',
  [CtxCities.SanSaba]: 'San Saba',
  [CtxCities.SanYgnacio]: 'San Ygnacio',
  [CtxCities.Sanctuary]: 'Sanctuary',
  [CtxCities.SandSprings]: 'Sand Springs',
  [CtxCities.Sanderson]: 'Sanderson',
  [CtxCities.Sandia]: 'Sandia',
  [CtxCities.Sandoval]: 'Sandoval',
  [CtxCities.SandyHollowEscondidas]: 'Sandy Hollow-Escondidas',
  [CtxCities.SandyPoint]: 'Sandy Point',
  [CtxCities.Sanford]: 'Sanford',
  [CtxCities.Sanger]: 'Sanger',
  [CtxCities.SansomPark]: 'Sansom Park',
  [CtxCities.SantaAnna]: 'Santa Anna',
  [CtxCities.SantaClara]: 'Santa Clara',
  [CtxCities.SantaCruz]: 'Santa Cruz',
  [CtxCities.SantaFe]: 'Santa Fe',
  [CtxCities.SantaMaria]: 'Santa Maria',
  [CtxCities.SantaMonica]: 'Santa Monica',
  [CtxCities.SantaRosa]: 'Santa Rosa',
  [CtxCities.Santel]: 'Santel',
  [CtxCities.Sarita]: 'Sarita',
  [CtxCities.Savannah]: 'Savannah',
  [CtxCities.Savoy]: 'Savoy',
  [CtxCities.ScenicOaks]: 'Scenic Oaks',
  [CtxCities.Schertz]: 'Schertz',
  [CtxCities.Schroeder]: 'Schroeder',
  [CtxCities.Schulenburg]: 'Schulenburg',
  [CtxCities.Schwertner]: 'Schwertner',
  [CtxCities.Scissors]: 'Scissors',
  [CtxCities.Scotland]: 'Scotland',
  [CtxCities.Scottsville]: 'Scottsville',
  [CtxCities.Scurry]: 'Scurry',
  [CtxCities.Seabrook]: 'Seabrook',
  [CtxCities.Seadrift]: 'Seadrift',
  [CtxCities.Seagoville]: 'Seagoville',
  [CtxCities.Seagraves]: 'Seagraves',
  [CtxCities.Sealy]: 'Sealy',
  [CtxCities.Sebastian]: 'Sebastian',
  [CtxCities.SecoMines]: 'Seco Mines',
  [CtxCities.Seguin]: 'Seguin',
  [CtxCities.Selma]: 'Selma',
  [CtxCities.Seminole]: 'Seminole',
  [CtxCities.Serenada]: 'Serenada',
  [CtxCities.SethWard]: 'Seth Ward',
  [CtxCities.SevenOaks]: 'Seven Oaks',
  [CtxCities.SevenPoints]: 'Seven Points',
  [CtxCities.Seymour]: 'Seymour',
  [CtxCities.ShadyHollow]: 'Shady Hollow',
  [CtxCities.ShadyShores]: 'Shady Shores',
  [CtxCities.Shadybrook]: 'Shadybrook',
  [CtxCities.Shallowater]: 'Shallowater',
  [CtxCities.Shamrock]: 'Shamrock',
  [CtxCities.ShavanoPark]: 'Shavano Park',
  [CtxCities.Sheldon]: 'Sheldon',
  [CtxCities.Shenandoah]: 'Shenandoah',
  [CtxCities.Shepherd]: 'Shepherd',
  [CtxCities.Sheridan]: 'Sheridan',
  [CtxCities.Sherman]: 'Sherman',
  [CtxCities.SherwoodShores]: 'Sherwood Shores',
  [CtxCities.Shiner]: 'Shiner',
  [CtxCities.Shoreacres]: 'Shoreacres',
  [CtxCities.SiennaPlantation]: 'Sienna Plantation',
  [CtxCities.SierraBlanca]: 'Sierra Blanca',
  [CtxCities.SiestaAcres]: 'Siesta Acres',
  [CtxCities.SiestaShores]: 'Siesta Shores',
  [CtxCities.Silsbee]: 'Silsbee',
  [CtxCities.Silverton]: 'Silverton',
  [CtxCities.Simonton]: 'Simonton',
  [CtxCities.Sinton]: 'Sinton',
  [CtxCities.Skellytown]: 'Skellytown',
  [CtxCities.Skidmore]: 'Skidmore',
  [CtxCities.Slaton]: 'Slaton',
  [CtxCities.Smiley]: 'Smiley',
  [CtxCities.Smithville]: 'Smithville',
  [CtxCities.Smyer]: 'Smyer',
  [CtxCities.Snook]: 'Snook',
  [CtxCities.Snyder]: 'Snyder',
  [CtxCities.Socorro]: 'Socorro',
  [CtxCities.Solis]: 'Solis',
  [CtxCities.Somerset]: 'Somerset',
  [CtxCities.Somerville]: 'Somerville',
  [CtxCities.Sonora]: 'Sonora',
  [CtxCities.SourLake]: 'Sour Lake',
  [CtxCities.SouthAlamo]: 'South Alamo',
  [CtxCities.SouthForkeStates]: 'South Fork eStates',
  [CtxCities.SouthHouston]: 'South Houston',
  [CtxCities.SouthLaPaloma]: 'South La Paloma',
  [CtxCities.SouthMountain]: 'South Mountain',
  [CtxCities.SouthPadreIsland]: 'South Padre Island',
  [CtxCities.SouthPoint]: 'South Point',
  [CtxCities.SouthToledoBend]: 'South Toledo Bend',
  [CtxCities.Southlake]: 'Southlake',
  [CtxCities.Southmayd]: 'Southmayd',
  [CtxCities.SouthsidePlace]: 'Southside Place',
  [CtxCities.Spade]: 'Spade',
  [CtxCities.Sparks]: 'Sparks',
  [CtxCities.Spearman]: 'Spearman',
  [CtxCities.Spicewood]: 'Spicewood',
  [CtxCities.Splendora]: 'Splendora',
  [CtxCities.Spofford]: 'Spofford',
  [CtxCities.Spring]: 'Spring',
  [CtxCities.SpringBranch]: 'Spring Branch',
  [CtxCities.SpringGardens]: 'Spring Gardens',
  [CtxCities.SpringValleyVillage]: 'Spring Valley Village',
  [CtxCities.Springlake]: 'Springlake',
  [CtxCities.Springtown]: 'Springtown',
  [CtxCities.Spur]: 'Spur',
  [CtxCities.StJo]: 'St. Jo',
  [CtxCities.StPaul]: 'St. Paul',
  [CtxCities.Stafford]: 'Stafford',
  [CtxCities.Stagecoach]: 'Stagecoach',
  [CtxCities.Stairtown]: 'Stairtown',
  [CtxCities.Stamford]: 'Stamford',
  [CtxCities.Stanton]: 'Stanton',
  [CtxCities.Staples]: 'Staples',
  [CtxCities.StarHarbor]: 'Star Harbor',
  [CtxCities.Stephenville]: 'Stephenville',
  [CtxCities.SterlingCity]: 'Sterling City',
  [CtxCities.Stinnett]: 'Stinnett',
  [CtxCities.Stockdale]: 'Stockdale',
  [CtxCities.Stonewall]: 'Stonewall',
  [CtxCities.Stowell]: 'Stowell',
  [CtxCities.Stratford]: 'Stratford',
  [CtxCities.Strawn]: 'Strawn',
  [CtxCities.Streetman]: 'Streetman',
  [CtxCities.StudyButte]: 'Study Butte',
  [CtxCities.Sublime]: 'Sublime',
  [CtxCities.Sudan]: 'Sudan',
  [CtxCities.SugarLand]: 'Sugar Land',
  [CtxCities.SullivanCity]: 'Sullivan City',
  [CtxCities.SulphurSprings]: 'Sulphur Springs',
  [CtxCities.SunValley]: 'Sun Valley',
  [CtxCities.Sundown]: 'Sundown',
  [CtxCities.Sunnyvale]: 'Sunnyvale',
  [CtxCities.Sunray]: 'Sunray',
  [CtxCities.SunriseBeach]: 'Sunrise Beach',
  [CtxCities.SunriseBeachVillage]: 'Sunrise Beach Village',
  [CtxCities.Sunset]: 'Sunset',
  [CtxCities.SunsetAcres]: 'Sunset Acres',
  [CtxCities.SunsetValley]: 'Sunset Valley',
  [CtxCities.SurfsideBeach]: 'Surfside Beach',
  [CtxCities.SutherlandSprings]: 'Sutherland Springs',
  [CtxCities.Sweeny]: 'Sweeny',
  [CtxCities.SweetHome]: 'Sweet Home',
  [CtxCities.Sweetwater]: 'Sweetwater',
  [CtxCities.Taft]: 'Taft',
  [CtxCities.TaftSouthwest]: 'Taft Southwest',
  [CtxCities.Tahoka]: 'Tahoka',
  [CtxCities.Talco]: 'Talco',
  [CtxCities.Talty]: 'Talty',
  [CtxCities.TanquecitosSouthAcres]: 'Tanquecitos South Acres',
  [CtxCities.TanquecitosSouthAcresII]: 'Tanquecitos South Acres II',
  [CtxCities.Tatum]: 'Tatum',
  [CtxCities.Taylor]: 'Taylor',
  [CtxCities.TaylorLakeVillage]: 'Taylor Lake Village',
  [CtxCities.TaylorLanding]: 'Taylor Landing',
  [CtxCities.Teague]: 'Teague',
  [CtxCities.Tehuacana]: 'Tehuacana',
  [CtxCities.Telferner]: 'Telferner',
  [CtxCities.Temple]: 'Temple',
  [CtxCities.Tenaha]: 'Tenaha',
  [CtxCities.TennesseeColony]: 'Tennessee Colony',
  [CtxCities.Terlingua]: 'Terlingua',
  [CtxCities.Terrell]: 'Terrell',
  [CtxCities.TerrellHills]: 'Terrell Hills',
  [CtxCities.Texarkana]: 'Texarkana',
  [CtxCities.TexasCity]: 'Texas City',
  [CtxCities.Texhoma]: 'Texhoma',
  [CtxCities.Texline]: 'Texline',
  [CtxCities.TheColony]: 'The Colony',
  [CtxCities.TheHills]: 'The Hills',
  [CtxCities.TheWoodlands]: 'The Woodlands',
  [CtxCities.Thomaston]: 'Thomaston',
  [CtxCities.Thompsons]: 'Thompsons',
  [CtxCities.Thompsonville]: 'Thompsonville',
  [CtxCities.Thorndale]: 'Thorndale',
  [CtxCities.Thornton]: 'Thornton',
  [CtxCities.Thorntonville]: 'Thorntonville',
  [CtxCities.Thrall]: 'Thrall',
  [CtxCities.ThreeRivers]: 'Three Rivers',
  [CtxCities.Throckmorton]: 'Throckmorton',
  [CtxCities.ThunderbirdBay]: 'Thunderbird Bay',
  [CtxCities.TierraBonita]: 'Tierra Bonita',
  [CtxCities.TierraDorada]: 'Tierra Dorada',
  [CtxCities.TierraGrande]: 'Tierra Grande',
  [CtxCities.TierraVerde]: 'Tierra Verde',
  [CtxCities.TikiIsland]: 'Tiki Island',
  [CtxCities.Tilden]: 'Tilden',
  [CtxCities.TimbercreekCanyon]: 'Timbercreek Canyon',
  [CtxCities.TimberwoodPark]: 'Timberwood Park',
  [CtxCities.Timpson]: 'Timpson',
  [CtxCities.Tioga]: 'Tioga',
  [CtxCities.Tira]: 'Tira',
  [CtxCities.Tivoli]: 'Tivoli',
  [CtxCities.Toco]: 'Toco',
  [CtxCities.ToddMission]: 'Todd Mission',
  [CtxCities.Tolar]: 'Tolar',
  [CtxCities.TomBean]: 'Tom Bean',
  [CtxCities.Tomball]: 'Tomball',
  [CtxCities.Tool]: 'Tool',
  [CtxCities.Topsey]: 'Topsey',
  [CtxCities.Tornillo]: 'Tornillo',
  [CtxCities.Tow]: 'Tow',
  [CtxCities.Toyah]: 'Toyah',
  [CtxCities.Tradewinds]: 'Tradewinds',
  [CtxCities.TravisRanch]: 'Travis Ranch',
  [CtxCities.Trent]: 'Trent',
  [CtxCities.Trenton]: 'Trenton',
  [CtxCities.Trinidad]: 'Trinidad',
  [CtxCities.Trinity]: 'Trinity',
  [CtxCities.TrophyClub]: 'Trophy Club',
  [CtxCities.Troup]: 'Troup',
  [CtxCities.Troy]: 'Troy',
  [CtxCities.Tuleta]: 'Tuleta',
  [CtxCities.Tulia]: 'Tulia',
  [CtxCities.Tulsita]: 'Tulsita',
  [CtxCities.Turkey]: 'Turkey',
  [CtxCities.Tuscola]: 'Tuscola',
  [CtxCities.Tye]: 'Tye',
  [CtxCities.Tyler]: 'Tyler',
  [CtxCities.Tynan]: 'Tynan',
  [CtxCities.Uhland]: 'Uhland',
  [CtxCities.UnionGrove]: 'Union Grove',
  [CtxCities.UnionValley]: 'Union Valley',
  [CtxCities.UniversalCity]: 'Universal City',
  [CtxCities.UniversityPark]: 'University Park',
  [CtxCities.Utopia]: 'Utopia',
  [CtxCities.Uvalde]: 'Uvalde',
  [CtxCities.UvaldeeStates]: 'Uvalde eStates',
  [CtxCities.ValVerdePark]: 'Val Verde Park',
  [CtxCities.Valentine]: 'Valentine',
  [CtxCities.ValleHermoso]: 'Valle Hermoso',
  [CtxCities.ValleVerde]: 'Valle Verde',
  [CtxCities.ValleVista]: 'Valle Vista',
  [CtxCities.ValleyMills]: 'Valley Mills',
  [CtxCities.ValleyView]: 'Valley View',
  [CtxCities.Van]: 'Van',
  [CtxCities.VanAlstyne]: 'Van Alstyne',
  [CtxCities.VanHorn]: 'Van Horn',
  [CtxCities.VanVleck]: 'Van Vleck',
  [CtxCities.Vanderbilt]: 'Vanderbilt',
  [CtxCities.Vanderpool]: 'Vanderpool',
  [CtxCities.Vega]: 'Vega',
  [CtxCities.Venture]: 'Venture',
  [CtxCities.Venus]: 'Venus',
  [CtxCities.Vernon]: 'Vernon',
  [CtxCities.Victoria]: 'Victoria',
  [CtxCities.VictoriaVera]: 'Victoria Vera',
  [CtxCities.Vidor]: 'Vidor',
  [CtxCities.VillaDelSol]: 'Villa del Sol',
  [CtxCities.VillaPancho]: 'Villa Pancho',
  [CtxCities.VillaVerde]: 'Villa Verde',
  [CtxCities.Villarreal]: 'Villarreal',
  [CtxCities.Vinton]: 'Vinton',
  [CtxCities.Volente]: 'Volente',
  [CtxCities.VonOrmy]: 'Von Ormy',
  [CtxCities.Waco]: 'Waco',
  [CtxCities.Waelder]: 'Waelder',
  [CtxCities.WakeVillage]: 'Wake Village',
  [CtxCities.Waller]: 'Waller',
  [CtxCities.Wallis]: 'Wallis',
  [CtxCities.WalnutSprings]: 'Walnut Springs',
  [CtxCities.Warren]: 'Warren',
  [CtxCities.WarrenCity]: 'Warren City',
  [CtxCities.Warrenton]: 'Warrenton',
  [CtxCities.Washington]: 'Washington',
  [CtxCities.Waskom]: 'Waskom',
  [CtxCities.Watauga]: 'Watauga',
  [CtxCities.Waxahachie]: 'Waxahachie',
  [CtxCities.Weatherford]: 'Weatherford',
  [CtxCities.Webberville]: 'Webberville',
  [CtxCities.Webster]: 'Webster',
  [CtxCities.Weesatche]: 'Weesatche',
  [CtxCities.Weimar]: 'Weimar',
  [CtxCities.Weinert]: 'Weinert',
  [CtxCities.Weir]: 'Weir',
  [CtxCities.Welch]: 'Welch',
  [CtxCities.Wellington]: 'Wellington',
  [CtxCities.Wellman]: 'Wellman',
  [CtxCities.Wells]: 'Wells',
  [CtxCities.WellsBranch]: 'Wells Branch',
  [CtxCities.Weslaco]: 'Weslaco',
  [CtxCities.West]: 'West',
  [CtxCities.WestAltoBonito]: 'West Alto Bonito',
  [CtxCities.WestColumbia]: 'West Columbia',
  [CtxCities.WestLakeHills]: 'West Lake Hills',
  [CtxCities.WestLivingston]: 'West Livingston',
  [CtxCities.WestOdessa]: 'West Odessa',
  [CtxCities.WestOrange]: 'West Orange',
  [CtxCities.WestSharyland]: 'West Sharyland',
  [CtxCities.WestTawakoni]: 'West Tawakoni',
  [CtxCities.WestUniversityPlace]: 'West University Place',
  [CtxCities.Westbrook]: 'Westbrook',
  [CtxCities.Westdale]: 'Westdale',
  [CtxCities.WesternLake]: 'Western Lake',
  [CtxCities.Westhoff]: 'Westhoff',
  [CtxCities.Westlake]: 'Westlake',
  [CtxCities.Westminster]: 'Westminster',
  [CtxCities.Weston]: 'Weston',
  [CtxCities.WestonLakes]: 'Weston Lakes',
  [CtxCities.WestoverHills]: 'Westover Hills',
  [CtxCities.Westphalia]: 'Westphalia',
  [CtxCities.Westway]: 'Westway',
  [CtxCities.WestwoodShores]: 'Westwood Shores',
  [CtxCities.WestworthVillage]: 'Westworth Village',
  [CtxCities.Wharton]: 'Wharton',
  [CtxCities.Wheeler]: 'Wheeler',
  [CtxCities.WhiteDeer]: 'White Deer',
  [CtxCities.WhiteOak]: 'White Oak',
  [CtxCities.WhiteSettlement]: 'White Settlement',
  [CtxCities.Whiteface]: 'Whiteface',
  [CtxCities.Whitehouse]: 'Whitehouse',
  [CtxCities.Whitesboro]: 'Whitesboro',
  [CtxCities.Whitewright]: 'Whitewright',
  [CtxCities.Whitney]: 'Whitney',
  [CtxCities.Whitsett]: 'Whitsett',
  [CtxCities.WichitaFalls]: 'Wichita Falls',
  [CtxCities.Wickett]: 'Wickett',
  [CtxCities.WildPeachVillage]: 'Wild Peach Village',
  [CtxCities.Wildwood]: 'Wildwood',
  [CtxCities.Willis]: 'Willis',
  [CtxCities.WillowPark]: 'Willow Park',
  [CtxCities.WillsPoint]: 'Wills Point',
  [CtxCities.Wilmer]: 'Wilmer',
  [CtxCities.Wilson]: 'Wilson',
  [CtxCities.Wimberley]: 'Wimberley',
  [CtxCities.Windcrest]: 'Windcrest',
  [CtxCities.Windemere]: 'Windemere',
  [CtxCities.Windom]: 'Windom',
  [CtxCities.Windthorst]: 'Windthorst',
  [CtxCities.Winfield]: 'Winfield',
  [CtxCities.Wink]: 'Wink',
  [CtxCities.Winnie]: 'Winnie',
  [CtxCities.Winnsboro]: 'Winnsboro',
  [CtxCities.Winona]: 'Winona',
  [CtxCities.Winters]: 'Winters',
  [CtxCities.WixonValley]: 'Wixon Valley',
  [CtxCities.WolfeCity]: 'Wolfe City',
  [CtxCities.Wolfforth]: 'Wolfforth',
  [CtxCities.WoodHi]: 'Wood Hi',
  [CtxCities.Woodbranch]: 'Woodbranch',
  [CtxCities.Woodcreek]: 'Woodcreek',
  [CtxCities.Woodloch]: 'Woodloch',
  [CtxCities.Woodsboro]: 'Woodsboro',
  [CtxCities.Woodson]: 'Woodson',
  [CtxCities.Woodville]: 'Woodville',
  [CtxCities.Woodway]: 'Woodway',
  [CtxCities.Wortham]: 'Wortham',
  [CtxCities.Wrightsboro]: 'Wrightsboro',
  [CtxCities.Wyldwood]: 'Wyldwood',
  [CtxCities.Wylie]: 'Wylie',
  [CtxCities.Yantis]: 'Yantis',
  [CtxCities.Yoakum]: 'Yoakum',
  [CtxCities.Yorktown]: 'Yorktown',
  [CtxCities.Youngsport]: 'Youngsport',
  [CtxCities.Yznaga]: 'Yznaga',
  [CtxCities.Zapata]: 'Zapata',
  [CtxCities.ZapataRanch]: 'Zapata Ranch',
  [CtxCities.Zarate]: 'Zarate',
  [CtxCities.Zavalla]: 'Zavalla',
  [CtxCities.Zuehl]: 'Zuehl'
};
